/* v1.0.0 — 2026-04-24 Signature Solar module with openness-based pricing */
/**
 * Builder Solar 2.0 — Solar Shade Module (EconoScreen 1%/3%)
 * 6-step config: Openness → Color → Mount & Size → Control Style → Roll Direction → Valance
 * Depends on window.BuilderCore (loaded first via defer order).
 * Identical to builder-roller-v2.js except for the "Choose Openness" step
 * which switches the price grid and color palette per openness level.
 */
(function() {
  'use strict';

  // Guard: only run on v2 builder pages
  if (!window.BuilderCore) {
    console.error('[BuilderRoller] BuilderCore not loaded');
    return;
  }

  var Core = window.BuilderCore;
  var dom = Core.dom;
  var events = Core.events;
  var fractions = Core.fractions;

  /* ============================================================
     PARSE DATA BRIDGES
     ============================================================ */
  var pricingData = Core.parseJSON('builder-pricing-data');
  var componentsData = Core.parseJSON('builder-components-data');
  var parentData = Core.parseJSON('builder-parent-data');
  var surchargeVariants = Core.parseJSON('builder-surcharge-variants');

  if (!componentsData || !parentData) {
    console.error('[BuilderRoller] Missing data bridges');
    var stepsEl = document.querySelector('[data-builder-steps]');
    if (stepsEl) stepsEl.innerHTML = '<div class="builder-v2__error builder-v2__error--visible">Builder configuration missing. Ensure builder blocks are configured in the theme customizer.</div>';
    return;
  }

  if (!pricingData) {
    console.warn('[BuilderRoller] No pricing data found in metafield. Builder will use variant prices as fallback.');
  }

  /* ============================================================
     COMPARE AT MSRP MULTIPLIER
     parent_product.price and compare_at_price are both in cents in
     the JSON bridge. If compare_at > price, ratio is applied to the
     calculated builder total so the strikethrough MSRP scales with
     size and options. Zero = no compare at, hide MSRP.
     ============================================================ */
  // Spend & Save shows no MSRP and sends the cart no compare saving.
  var ssMode = !!document.querySelector('[data-ss-price-card]');
  var msrpMultiplier = (function() {
    if (!parentData || ssMode) return 0;
    var p = parseFloat(parentData.price) || 0;
    var c = parseFloat(parentData.compare_at_price) || 0;
    return (c > p && p > 0) ? c / p : 0;
  })();

  function renderMsrp(pos, baseAmount) {
    var el = document.querySelector('[data-msrp][data-msrp-pos="' + pos + '"]');
    if (!el) return;
    if (msrpMultiplier <= 0) {
      el.style.display = 'none';
      return;
    }
    if (baseAmount > 0) {
      var msrp = Math.round(baseAmount * msrpMultiplier * 100) / 100;
      var v = el.querySelector('[data-msrp-value]');
      if (v) v.textContent = Core.formatMoney(msrp);
    }
    el.style.display = '';
  }

  // The card's Affirm line is not data-affirm-live, so it follows the top price instead of the bar total.
  var ssAffirmTimer = null;
  function syncSsAffirm(amount) {
    var el = document.querySelector('[data-ss-price-card] [data-affirm-context="pdp-top"]');
    if (!el || !(amount > 0)) return;
    var cents = String(Math.round(amount * 100));
    if (el.getAttribute('data-amount') === cents) return;
    el.setAttribute('data-amount', cents);
    if (ssAffirmTimer) clearTimeout(ssAffirmTimer);
    ssAffirmTimer = setTimeout(function() {
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh();
    }, 150);
  }


  /* ============================================================
     FREE SAMPLE ATC
     Per-swatch ORDER SAMPLE button. Lazy-fetches the configured
     sample collection JSON, matches builder color SKU to sample
     variant ID, AJAX adds to cart with vendor=FDB Sample, toggles
     button state. Pre-flight checks the global isValidCart guard
     for mixed-cart and 10-sample cap. Out-of-stock samples render
     greyed and disabled.
     ============================================================ */
  var SampleATC = (function() {
    var configEl = document.getElementById('builder-sample-config');
    var config = configEl ? JSON.parse(configEl.textContent) : {};
    var collectionHandle = (config && config.sampleCollection) || '';
    var samplesBySku = null;
    var samplesByVariantId = null;
    var fetchPromise = null;
    var enabled = !!collectionHandle;
    var SAMPLE_CAP = 10;

    function fetchSamples() {
      if (!enabled) return Promise.resolve(null);
      if (samplesBySku) return Promise.resolve(samplesBySku);
      if (fetchPromise) return fetchPromise;
      fetchPromise = fetch('/collections/' + collectionHandle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          samplesBySku = {};
          samplesByVariantId = {};
          (json.products || []).forEach(function(p) {
            var v = p.variants && p.variants[0];
            if (!v) return;
            var sample = {
              id: v.id,
              name: p.title,
              handle: p.handle,
              image: (p.images && p.images[0] && p.images[0].src) || '',
              available: v.available !== false,
              sku: v.sku || ''
            };
            if (sample.sku) samplesBySku[String(sample.sku).trim().toLowerCase()] = sample;
            if (sample.id) samplesByVariantId[sample.id] = sample;
          });
          return samplesBySku;
        })
        .catch(function(e) {
          console.warn('[SampleATC] fetch failed', e);
          samplesBySku = {};
          return samplesBySku;
        });
      return fetchPromise;
    }

    function findBySku(sku) {
      if (!sku || !samplesBySku) return null;
      return samplesBySku[String(sku).trim().toLowerCase()] || null;
    }

    function showToast(msg, isError) {
      if (typeof Flash === 'function') {
        try { (new Flash(msg, { isError: !!isError })).show(); return; } catch(e) {}
      }
      console[isError ? 'warn' : 'log']('[SampleATC]', msg);
    }

    var cartCache = null;
    var cartPromise = null;

    function isSampleItem(item) {
      return item && /FDB Sample/i.test(item.vendor || '');
    }

    function sampleQtyInCart(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.filter(isSampleItem).reduce(function(s, i) { return s + (i.quantity || 0); }, 0);
    }

    function getCart() {
      if (cartCache) return Promise.resolve(cartCache);
      if (cartPromise) return cartPromise;
      cartPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartCache = cart;
          cartPromise = null;
          updateCapState(cart);
          return cart;
        })
        .catch(function(e) {
          cartPromise = null;
          throw e;
        });
      return cartPromise;
    }

    // Header bubble has a theme bug: buildCart adds .hide on empty but never
    // removes it on the 0->1 transition. Toggle it explicitly here.
    function updateNavCart(itemCount) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = itemCount; });
      document.querySelectorAll('[data-cart-count-bubble]').forEach(function(el) {
        if (itemCount > 0) el.classList.remove('hide');
        else el.classList.add('hide');
      });
    }

    // Drawer rebuild via the theme's existing ajaxCart loader so an open
    // drawer reflects sample add/remove instead of staying stale.
    function rebuildDrawer() {
      try {
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') window.ajaxCart.load();
      } catch (e) { console.warn('[SampleATC] drawer rebuild failed', e); }
    }

    function updateCapState(cart) {
      var atCap = sampleQtyInCart(cart) >= SAMPLE_CAP;
      document.querySelectorAll('.builder-v2__sample-btn').forEach(function(btn) {
        if (btn.classList.contains('builder-v2__sample-btn--in-cart')) return;
        if (btn.classList.contains('builder-v2__sample-btn--out-of-stock')) return;
        if (btn.classList.contains('builder-v2__sample-btn--loading')) return;
        if (atCap) {
          btn.classList.add('builder-v2__sample-btn--cap-reached');
          btn.textContent = 'Cart full (10/10)';
        } else if (btn.classList.contains('builder-v2__sample-btn--cap-reached')) {
          btn.classList.remove('builder-v2__sample-btn--cap-reached');
          btn.textContent = 'Free Sample';
        }
      });
    }

    function applyCartResponse(cart) {
      cartCache = cart;
      updateNavCart(cart.item_count || 0);
      updateCapState(cart);
      rebuildDrawer();
    }

    document.addEventListener('cart:updated', function(e) {
      if (e && e.detail && e.detail.source === 'sample-atc') return;
      cartCache = null;
    });

    function setButtonState(btn, state, sample) {
      btn.classList.remove('builder-v2__sample-btn--in-cart', 'builder-v2__sample-btn--out-of-stock', 'builder-v2__sample-btn--loading', 'builder-v2__sample-btn--cap-reached');
      btn.removeAttribute('aria-disabled');
      var wrapper = btn.closest('.builder-v2__swatch-wrapper');
      if (state === 'in-cart') {
        btn.classList.add('builder-v2__sample-btn--in-cart');
        btn.innerHTML = 'Added <span class="builder-v2__sample-check" aria-hidden="true">&#10003;</span>';
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Remove ' + (sample && sample.name ? sample.name : 'sample') + ' from cart');
        btn.setAttribute('title', 'Click to remove');
        if (wrapper) wrapper.classList.add('builder-v2__swatch-wrapper--sample-in-cart');
      } else if (state === 'out-of-stock') {
        btn.classList.add('builder-v2__sample-btn--out-of-stock');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Free Sample';
        btn.setAttribute('aria-label', 'Free sample of ' + (sample && sample.name ? sample.name : 'this color') + ' (out of stock)');
        btn.setAttribute('aria-pressed', 'false');
        btn.removeAttribute('title');
        if (wrapper) wrapper.classList.remove('builder-v2__swatch-wrapper--sample-in-cart');
      } else if (state === 'loading') {
        btn.classList.add('builder-v2__sample-btn--loading');
        btn.textContent = '';
        btn.removeAttribute('title');
      } else {
        btn.textContent = 'Free Sample';
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Free sample of ' + (sample && sample.name ? sample.name : 'this color'));
        btn.removeAttribute('title');
        if (wrapper) wrapper.classList.remove('builder-v2__swatch-wrapper--sample-in-cart');
      }
    }

    function syncButtonsForVariant(variantId, state, sample) {
      var btns = document.querySelectorAll('[data-sample-variant="' + variantId + '"]');
      btns.forEach(function(btn) { setButtonState(btn, state, sample); });
    }

    function attachButton(wrapper, sku, colorName) {
      if (!enabled) return;
      var existing = wrapper.querySelector('.builder-v2__sample-btn');
      if (existing) existing.remove();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'builder-v2__sample-btn';
      btn.textContent = 'Free Sample';
      btn.setAttribute('aria-pressed', 'false');
      // Reserve grid slot before knowing if a sample exists. visibility (not
      // display) keeps row height consistent — no flicker, no layout shift.
      btn.style.visibility = 'hidden';
      btn.style.pointerEvents = 'none';
      wrapper.appendChild(btn);

      fetchSamples().then(function() {
        var sample = findBySku(sku);
        if (!sample) return; // No sample for this SKU — slot stays invisible.
        btn.setAttribute('data-sample-variant', sample.id);
        btn.setAttribute('aria-label', 'Order ' + (sample.name || colorName || 'sample'));
        btn.style.visibility = '';
        btn.style.pointerEvents = '';

        if (sample.available === false) {
          setButtonState(btn, 'out-of-stock', sample);
          return;
        }

        getCart().then(function(cart) {
          var inCart = (cart.items || []).some(function(i) { return i.variant_id === sample.id; });
          setButtonState(btn, inCart ? 'in-cart' : 'default', sample);
          if (!inCart && sampleQtyInCart(cart) >= SAMPLE_CAP) {
            btn.classList.add('builder-v2__sample-btn--cap-reached');
            btn.textContent = 'Cart full (10/10)';
          }
        }).catch(function() {
          setButtonState(btn, 'default', sample);
        });
      });

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('builder-v2__sample-btn--out-of-stock')) return;
        if (btn.classList.contains('builder-v2__sample-btn--loading')) return;
        if (btn.classList.contains('builder-v2__sample-btn--cap-reached')) {
          showToast('Maximum 10 free samples per order.', true);
          return;
        }
        var variantId = parseInt(btn.getAttribute('data-sample-variant'), 10);
        if (!variantId) return;
        var sample = (samplesByVariantId && samplesByVariantId[variantId]) || null;

        if (btn.classList.contains('builder-v2__sample-btn--in-cart')) {
          // REMOVE: /cart/update.js with quantity=0 returns the full cart
          // (unlike change.js). One round-trip, authoritative response.
          setButtonState(btn, 'loading', sample);
          var updates = {};
          updates[variantId] = 0;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function(r) {
            if (!r.ok) throw new Error('Remove failed: ' + r.status);
            return r.json();
          }).then(function(cart) {
            syncButtonsForVariant(variantId, 'default', sample);
            applyCartResponse(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sample-atc' } }));
          }).catch(function() {
            syncButtonsForVariant(variantId, 'in-cart', sample);
            showToast('Could not remove sample. Please try again.', true);
          });
          return;
        }

        // ADD: pre-flight against shared cart cache.
        setButtonState(btn, 'loading', sample);
        getCart().then(function(cart) {
          var items = cart.items || [];
          var hasNonSample = items.some(function(i) { return !isSampleItem(i); });
          var sampleQty = sampleQtyInCart(cart);

          if (hasNonSample) {
            setButtonState(btn, 'default', sample);
            showToast('Free samples must be ordered separately. Please complete your current order first.', true);
            return null;
          }
          if (sampleQty >= SAMPLE_CAP) {
            setButtonState(btn, 'default', sample);
            updateCapState(cart);
            showToast('Maximum 10 free samples per order.', true);
            return null;
          }

          // /cart/add.js returns only the line item, so follow with /cart.js
          // for authoritative item_count + items list.
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function(r) {
            if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || err.message || 'Add failed'); });
            return r.json();
          }).then(function() {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
          }).then(function(freshCart) {
            syncButtonsForVariant(variantId, 'in-cart', sample);
            applyCartResponse(freshCart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sample-atc' } }));
          });
        }).catch(function(e) {
          setButtonState(btn, 'default', sample);
          showToast((e && e.message) || 'Could not add sample. Please try again.', true);
        });
      });
    }

    // Pre-warm both fetches at module init so the first user click doesn't
    // pay for cold caches. fetchSamples and getCart kick off in parallel.
    if (enabled) {
      fetchSamples();
      getCart();
    }

    return {
      enabled: enabled,
      attachButton: attachButton,
      fetchSamples: fetchSamples
    };
  })();


  /* ============================================================
     STATE STORE
     ============================================================ */
  var store = Core.createStore({
    openness: null,
    opennessLabel: null,
    colorGroup: null,
    colorName: null,
    colorSku: null,
    colorImage: null,
    colorProductId: null,
    colorVariantId: null,
    mount: null,
    widthInt: null,
    widthFrac: 0,
    heightInt: null,
    heightFrac: 0,
    control: null,
    controlLabel: null,
    controlSurcharge: 0,
    rollDirection: null,
    roomName: '',
    measuresafe: false,
    shippingUpgrade: false,
    valanceType: null,
    valanceLabel: null,
    valancePrice: 0,
    oversizeSurcharge: 0,
    quantity: 1,
    basePrice: 0,
    totalPrice: 0,
    sizeVariantId: null
  });

  /* ============================================================
     PRICING ENGINE INIT
     ============================================================ */
  var pricing = pricingData ? new Core.PricingEngine(pricingData) : null;

  /* ============================================================
     FIND COMPONENT BLOCKS BY TYPE
     ============================================================ */
  function findBlock(type) {
    if (!componentsData || !componentsData.blocks) return null;
    for (var i = 0; i < componentsData.blocks.length; i++) {
      if (componentsData.blocks[i].type === type) return componentsData.blocks[i];
    }
    return null;
  }

  function findSizeBlock() {
    return findBlock('size');
  }

  function findColorBlock() {
    return findBlock('color');
  }

  /**
   * Get the line item property key name from a block's config.
   * Searches by block type first, then by builder_type.
   * Falls back to provided default if not found.
   * This ensures EDI keys match whatever the merchant configured in the theme customizer.
   */
  function getBlockPropertyKey(blockType, fallback) {
    // Search by block type (e.g. 'color', 'size')
    var block = findBlock(blockType);
    if (block && block.property) return block.property;
    // Search by builder_type (e.g. 'Mount', 'Lift Cord')
    if (componentsData && componentsData.blocks) {
      for (var i = 0; i < componentsData.blocks.length; i++) {
        if (componentsData.blocks[i].builder_type === blockType) {
          return componentsData.blocks[i].property || fallback;
        }
      }
    }
    return fallback;
  }

  /* ============================================================
     SIZE VARIANT HELPERS
     Parse "WIDTHxHEIGHT" variant titles from the -1 product.
     Cached after first parse to avoid re-processing on every size change.
     ============================================================ */
  var _sizeVariantsCache = null;
  function parseSizeVariants() {
    if (_sizeVariantsCache !== null) return _sizeVariantsCache;
    var sizeBlock = findSizeBlock();
    if (!sizeBlock || !sizeBlock.products || sizeBlock.products.length === 0) {
      _sizeVariantsCache = [];
      return _sizeVariantsCache;
    }
    // Solar: pick the size product matching the active openness level.
    // Openness IDs are "1pct","3pct","5pct"; size product handles contain
    // "1-solar","3-solar","5-solar". Match the numeric prefix.
    var product = sizeBlock.products[0]; // default fallback
    var openness = store.get('openness');
    if (openness && sizeBlock.products.length > 1) {
      var opennessNum = openness.replace('pct', '');
      for (var si = 0; si < sizeBlock.products.length; si++) {
        if (sizeBlock.products[si].handle &&
            sizeBlock.products[si].handle.indexOf(opennessNum + '-solar') !== -1) {
          product = sizeBlock.products[si];
          break;
        }
      }
    }
    var variants = [];
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var normalized = v.title.replace(/\s/g, '').toLowerCase();
      var parts = normalized.split('x');
      if (parts.length === 2 && !isNaN(parseInt(parts[0], 10)) && !isNaN(parseInt(parts[1], 10))) {
        variants.push({
          id: v.id,
          width: parseInt(parts[0], 10),
          height: parseInt(parts[1], 10),
          price: v.price / 100,
          title: parseInt(parts[0], 10) + 'x' + parseInt(parts[1], 10)
        });
      }
    }
    _sizeVariantsCache = variants;
    return variants;
  }

  /**
   * Resolve a Shopify variant ID to anchor the cart line for a given
   * tier width x tier height. The variant is just an anchor - real price
   * and dimensions ride on line item properties (_BundleSubtotal, Width,
   * Height, etc.) for LogicBroker EDI. So we never want this to return
   * null while the user has a valid configuration.
   *
   * Resolution order:
   *   1. Exact "WxH" match in the size block product (if its variants
   *      are titled in WxH format).
   *   2. First parsed size variant (for size products that have anchor
   *      variants but not titled in WxH format).
   *   3. Parent product's first available variant from parentData.
   *
   * @param {number} tierWidth
   * @param {number} tierHeight
   * @returns {number|null}
   */
  function findSizeVariantId(tierWidth, tierHeight) {
    var variants = parseSizeVariants();

    // 1. Exact tier match
    var target = tierWidth + 'x' + tierHeight;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === target) return variants[i].id;
    }

    // 2. Closest variant >= tier dimensions (round-up match).
    //    Pricing tiers may use 6" increments but size variants use 12",
    //    so exact match can miss. Pick the smallest variant that covers
    //    the tier dimensions so checkout charges the correct amount.
    if (variants.length > 0 && tierWidth > 0 && tierHeight > 0) {
      var bestVariant = null;
      var bestDiff = Infinity;
      for (var vi = 0; vi < variants.length; vi++) {
        if (variants[vi].width >= tierWidth && variants[vi].height >= tierHeight) {
          var diff = (variants[vi].width - tierWidth) + (variants[vi].height - tierHeight);
          if (diff < bestDiff) {
            bestDiff = diff;
            bestVariant = variants[vi];
          }
        }
      }
      if (bestVariant) return bestVariant.id;
    }

    // 3. First parsed size variant fallback
    if (variants.length > 0) return variants[0].id;

    // 3. Raw first variant of the size block product (not WxH titled)
    var sizeBlock = findSizeBlock();
    if (sizeBlock && sizeBlock.products && sizeBlock.products.length > 0) {
      var sp = sizeBlock.products[0];
      if (sp.variants && sp.variants.length > 0) return sp.variants[0].id;
    }

    // 4. Parent product variant as ultimate anchor
    if (parentData && parentData.variant_id) return parentData.variant_id;

    return null;
  }

  /* ============================================================
     GENERATE SEQUENTIAL RANGE
     ============================================================ */
  function range(min, max) {
    var arr = [];
    for (var i = min; i <= max; i++) arr.push(i);
    return arr;
  }


  /* ============================================================
     INLINE SVG ICONS — High-quality filled illustrations (80x80 viewBox)
     Must be defined before STEPS array since render functions reference ICONS.
     ============================================================ */
  var ICONS = {
    // STEP 2: MOUNT TYPE
    insideMount: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="10" y="10" width="60" height="60" rx="2" fill="#F5F5F5" stroke="#607D8B" stroke-width="3"/>' +
      '<rect x="14" y="14" width="52" height="52" rx="1" fill="#fff" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="20" y="18" width="40" height="6" rx="3" fill="#13548d"/>' +
      '<rect x="20" y="24" width="40" height="36" fill="#E8EDF2" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M18 40l-4 3v-6l4 3z" fill="#13548d" opacity=".6"/>' +
      '<path d="M62 40l4-3v6l-4-3z" fill="#13548d" opacity=".6"/>' +
      '</svg>',
    outsideMount: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="16" y="20" width="48" height="50" rx="2" fill="#F5F5F5" stroke="#607D8B" stroke-width="3"/>' +
      '<rect x="20" y="24" width="40" height="42" rx="1" fill="#fff" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="8" y="12" width="64" height="6" rx="3" fill="#13548d"/>' +
      '<rect x="8" y="18" width="64" height="40" fill="#E8EDF2" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M10 38l-6 4v-8l6 4z" fill="#13548d" opacity=".6"/>' +
      '<path d="M70 38l6-4v8l-6-4z" fill="#13548d" opacity=".6"/>' +
      '</svg>',

    // STEP 3: CONTROL STYLE
    chainLeft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="44" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="59" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<line x1="18" y1="17" x2="18" y2="30" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="18" cy="33" r="3" fill="#13548d"/><circle cx="18" cy="40" r="3" fill="#13548d"/>' +
      '<circle cx="18" cy="47" r="3" fill="#13548d"/><circle cx="18" cy="54" r="3" fill="#13548d"/>' +
      '<circle cx="18" cy="61" r="3" fill="#13548d"/><circle cx="18" cy="68" r="3" fill="#13548d"/>' +
      '<path d="M15 68q-3 4 0 8t6 0" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg>',
    chainRight: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="44" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="59" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<line x1="62" y1="17" x2="62" y2="30" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="62" cy="33" r="3" fill="#13548d"/><circle cx="62" cy="40" r="3" fill="#13548d"/>' +
      '<circle cx="62" cy="47" r="3" fill="#13548d"/><circle cx="62" cy="54" r="3" fill="#13548d"/>' +
      '<circle cx="62" cy="61" r="3" fill="#13548d"/><circle cx="62" cy="68" r="3" fill="#13548d"/>' +
      '<path d="M59 68q-3 4 0 8t6 0" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg>',
    cordless: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="34" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="49" width="52" height="4" rx="2" fill="#78909C" stroke="#607D8B" stroke-width="1"/>' +
      '<path d="M34 62c0-3 2-5 6-5s6 2 6 5" stroke="#455A64" stroke-width="3" stroke-linecap="round" fill="none"/>' +
      '<path d="M37 65l3-4 3 4" fill="#455A64"/>' +
      '<circle cx="40" cy="58" r="2" fill="#455A64"/>' +
      '<path d="M40 68v-4" stroke="#455A64" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M36 72h8" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".5"/>' +
      '</svg>',
    motorized: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="14" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="8" y="12" width="12" height="11" rx="3" fill="#455A64" stroke="#37474F" stroke-width="2"/>' +
      '<rect x="14" y="21" width="52" height="34" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="53" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<rect x="28" y="62" width="24" height="14" rx="4" fill="#fff" stroke="#13548d" stroke-width="2"/>' +
      '<circle cx="36" cy="69" r="2" fill="#13548d"/><circle cx="44" cy="69" r="2" fill="#13548d"/>' +
      '<circle cx="40" cy="65" r="1.5" fill="#13548d" opacity=".4"/>' +
      '<path d="M18 24c-4 2-7 0-9-2" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".4"/>' +
      '<path d="M16 28c-5 3-9 0-12-3" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".25"/>' +
      '</svg>',

    // STEP 4: ROLL DIRECTION — premium FRONT-VIEW redesign matching the
    // shopper's mental model (the view they have standing in their room).
    // Both icons render the blind hanging in a window with the TOP of the
    // assembly as the differentiator:
    //   - Standard = clean horizontal tube visible at top, fabric panel
    //     hanging behind it (you see the cylindrical aluminum bar).
    //   - Reverse  = fabric drapes OVER the front of the tube creating
    //     a visible "wave" / curled lip at the top. Tube hidden behind
    //     the fabric drape.
    // Gradients on fabric and tube add material depth; warm cream stroke
    // hints at the window frame for context without dominating; soft
    // floor shadow grounds the assembly.
    standardRoll: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        // Navy fabric gradient (FDB brand) — top highlight, mid body, deep base
        '<linearGradient id="stdFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="35%" stop-color="#155995"/>' +
          '<stop offset="100%" stop-color="#0a3a64"/>' +
        '</linearGradient>' +
        // Brushed-aluminum cylinder
        '<linearGradient id="stdTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#A6B0BD"/>' +
          '<stop offset="30%" stop-color="#FFFFFF"/>' +
          '<stop offset="58%" stop-color="#E5E9EF"/>' +
          '<stop offset="100%" stop-color="#6A7480"/>' +
        '</linearGradient>' +
        // Premium end cap with metallic light catch
        '<radialGradient id="stdCap" cx="0.3" cy="0.3" r="0.85">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#C5CDD8"/>' +
          '<stop offset="100%" stop-color="#4F5965"/>' +
        '</radialGradient>' +
        // Inner shadow at top of fabric (where it tucks behind tube)
        '<linearGradient id="stdInner" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#000" stop-opacity=".35"/>' +
          '<stop offset="100%" stop-color="#000" stop-opacity="0"/>' +
        '</linearGradient>' +
      '</defs>' +
      // Floor shadow — wider and darker for grounded weight
      '<ellipse cx="40" cy="76" rx="32" ry="1.7" fill="#000" opacity=".18"/>' +
      // FABRIC — fills ~90% of viewBox width for proper presence
      '<rect x="6" y="22" width="62" height="50" fill="url(#stdFab)"/>' +
      // Inner-shadow band at top (depth cue — fabric tucks behind tube)
      '<rect x="6" y="22" width="62" height="7" fill="url(#stdInner)"/>' +
      // Subtle vertical weave — gives it tactile fabric feel, not a flat plane
      '<line x1="18" y1="28" x2="18" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="29" y1="28" x2="29" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="40" y1="28" x2="40" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="51" y1="28" x2="51" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="62" y1="28" x2="62" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      // Bottom hem — darker accent strip
      '<rect x="4" y="69" width="66" height="4" rx="1.5" fill="#062340"/>' +
      // ALUMINUM TUBE — full-width across top, chunky and dominant
      '<rect x="6" y="11" width="62" height="13" rx="6.5" fill="url(#stdTub)" stroke="#3F4754" stroke-width="0.8"/>' +
      // Tube top sheen — bright cylindrical reflection
      '<rect x="9" y="12.5" width="56" height="1.7" rx="0.85" fill="#FFFFFF" opacity=".85"/>' +
      // RIGHT END CAP — prominent raised disc
      '<ellipse cx="68" cy="17.5" rx="6.5" ry="7" fill="url(#stdCap)" stroke="#3F4754" stroke-width="0.9"/>' +
      // Cap rim shadow for depth
      '<ellipse cx="68" cy="17.5" rx="6.5" ry="7" fill="none" stroke="#000" stroke-width="0.4" opacity=".25"/>' +
      // Clockwise rotation arrow (Standard direction)
      '<path d="M70.7 14.5 A 3.4 3.4 0 1 1 65.4 18" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round"/>' +
      '<path d="M65 16.3 L65.4 18.6 L67.6 17.9" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    // Reverse Roll — matched to SelectBlinds reference. The fabric
    // wraps OVER the tube and cascades down the front ("waterfall").
    // From the customer's viewing angle:
    //   1. Fabric fills the frame (tube hidden behind)
    //   2. Top-right diagonal notch where fabric wraps behind the tube
    //   3. SHORT ALUMINUM TUBE SEGMENT visible at the notch — the
    //      small exposed bar is the cue that says "there IS a tube
    //      behind this fabric, and the fabric went over it"
    //   4. End cap with rotation arrow at the tube's right end
    reverseRoll: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="revFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="35%" stop-color="#155995"/>' +
          '<stop offset="100%" stop-color="#0a3a64"/>' +
        '</linearGradient>' +
        // Same aluminum gradient as Standard (reused for tube segment)
        '<linearGradient id="revTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#A6B0BD"/>' +
          '<stop offset="30%" stop-color="#FFFFFF"/>' +
          '<stop offset="58%" stop-color="#E5E9EF"/>' +
          '<stop offset="100%" stop-color="#6A7480"/>' +
        '</linearGradient>' +
        '<radialGradient id="revCap" cx="0.3" cy="0.3" r="0.85">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#C5CDD8"/>' +
          '<stop offset="100%" stop-color="#4F5965"/>' +
        '</radialGradient>' +
      '</defs>' +
      '<ellipse cx="36" cy="76" rx="30" ry="1.7" fill="#000" opacity=".18"/>' +
      // SHORT TUBE SEGMENT visible at top-right — drawn FIRST so
      // the fabric overlaps its left portion. This is the visual cue
      // that distinguishes Reverse from a plain rectangle.
      '<rect x="48" y="10" width="20" height="13" rx="6.5" fill="url(#revTub)" stroke="#3F4754" stroke-width="0.7"/>' +
      // Tube sheen on the exposed segment
      '<rect x="50" y="11.5" width="16" height="1.5" rx="0.75" fill="#FFFFFF" opacity=".7"/>' +
      // FABRIC — full rectangle except the top-right is cut where
      // the fabric wraps behind the tube. The left edge of the cut
      // overlaps the tube segment slightly (fabric in front of tube).
      '<path d="M6 8 L48 8 Q 54 8 56 16 L56 72 L6 72 Z" fill="url(#revFab)"/>' +
      // Light catch on the top fabric edge
      '<line x1="6" y1="8.4" x2="48" y2="8.4" stroke="#FFFFFF" stroke-width="0.5" opacity=".35"/>' +
      // Shadow at the diagonal where fabric wraps behind tube
      '<path d="M48 8 Q 52 10 54 14" stroke="#041c33" stroke-width="0.8" opacity=".45" fill="none"/>' +
      // Vertical weave
      '<line x1="16" y1="12" x2="16" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="26" y1="12" x2="26" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="36" y1="12" x2="36" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="46" y1="12" x2="46" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      // Bottom hem
      '<rect x="4" y="69" width="60" height="4" rx="1.5" fill="#062340"/>' +
      // END CAP at the right end of the exposed tube
      '<ellipse cx="68" cy="16.5" rx="6.5" ry="7" fill="url(#revCap)" stroke="#3F4754" stroke-width="0.9"/>' +
      '<ellipse cx="68" cy="16.5" rx="6.5" ry="7" fill="none" stroke="#000" stroke-width="0.4" opacity=".25"/>' +
      // Counter-clockwise rotation arrow
      '<path d="M65.3 13 A 3.4 3.4 0 1 0 70.6 16.7" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round"/>' +
      '<path d="M71 14.9 L70.6 17.2 L68.4 16.6" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',

    // STEP 5: VALANCE OPTIONS — premium FRONT-VIEW redesign matching the
    // shopper's actual viewing angle. Each icon shows the blind hanging
    // in a window with the TOP element as the differentiator:
    //   - No Valance = visible bare aluminum tube + exposed brackets
    //     (utilitarian look, the mechanism is part of the aesthetic).
    //   - Fascia    = clean rectangular aluminum cover hides the tube
    //     (sharp modern profile).
    //   - Cassette  = curved sleek cover with FABRIC INSERT visible on
    //     the face (the upgrade — premium gradient + woven texture lines
    //     on the insert make it visually earn its surcharge).
    // Shared system: warm cream window-frame stroke, soft floor shadow,
    // gradient on every aluminum surface for material depth, gradient on
    // every fabric for woven feel.
    noValance: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="nvFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="nvTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="100%" stop-color="#C7CFD9"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".08"/>' +
      // Exposed mounting brackets (utility look)
      '<rect x="13" y="13" width="3" height="11" rx="0.5" fill="#8B98A8"/>' +
      '<rect x="64" y="13" width="3" height="11" rx="0.5" fill="#8B98A8"/>' +
      // Bare aluminum tube fully visible — the look IS the absence of cover
      '<rect x="16" y="14" width="48" height="8" rx="4" fill="url(#nvTub)" stroke="#13548d" stroke-width="1.4"/>' +
      '<rect x="18" y="15.5" width="44" height="1.2" rx="0.6" fill="#FFFFFF" opacity=".75"/>' +
      '<ellipse cx="16" cy="18" rx="1.6" ry="4" fill="#13548d" opacity=".4"/>' +
      '<ellipse cx="64" cy="18" rx="1.6" ry="4" fill="#13548d" opacity=".4"/>' +
      // Fabric panel below
      '<rect x="22" y="22" width="36" height="46" fill="url(#nvFab)"/>' +
      '<line x1="29" y1="26" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="26" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="26" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    fascia: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="fasFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="fasCov" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="60%" stop-color="#EFF2F6"/>' +
          '<stop offset="100%" stop-color="#C7CFD9"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".09"/>' +
      // Rectangular aluminum fascia — sharp 90° corners, modern profile
      '<rect x="14" y="11" width="52" height="14" rx="1.5" fill="url(#fasCov)" stroke="#13548d" stroke-width="1.5"/>' +
      // Crisp metallic top highlight
      '<rect x="16" y="12.5" width="48" height="1.2" rx="0.6" fill="#FFFFFF" opacity=".85"/>' +
      // End-cap suture lines (read as a 3D extrusion, not flat plane)
      '<line x1="20" y1="13" x2="20" y2="23" stroke="#13548d" stroke-width="0.6" opacity=".4"/>' +
      '<line x1="60" y1="13" x2="60" y2="23" stroke="#13548d" stroke-width="0.6" opacity=".4"/>' +
      // Bottom edge subtle shadow
      '<line x1="14" y1="25" x2="66" y2="25" stroke="#13548d" stroke-width="0.5" opacity=".25"/>' +
      // Fabric below
      '<rect x="22" y="25" width="36" height="43" fill="url(#fasFab)"/>' +
      '<line x1="29" y1="29" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="29" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="29" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    cassette: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="casFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="casShell" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#EFF2F6"/>' +
          '<stop offset="100%" stop-color="#B8C2CE"/>' +
        '</linearGradient>' +
        '<linearGradient id="casInsert" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2a7cc2"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      // Slightly darker shadow than fascia — premium products feel grounded
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".11"/>' +
      // Outer aluminum shell — flat top, curved bottom (D-profile)
      '<path d="M14 11 H66 V20 Q 66 27 60 27 H20 Q 14 27 14 20 Z" fill="url(#casShell)" stroke="#13548d" stroke-width="1.5" stroke-linejoin="round"/>' +
      // Premium top sheen (brighter than fascia — feels "pearlescent")
      '<rect x="16" y="12.5" width="48" height="1.4" rx="0.7" fill="#FFFFFF" opacity=".9"/>' +
      // FABRIC INSERT recessed into the shell face (the "fabric-covered"
      // feature that makes cassette an upgrade over plain aluminum fascia)
      '<path d="M19 14 H61 V19 Q 61 24 56 24 H24 Q 19 24 19 19 Z" fill="url(#casInsert)"/>' +
      // Woven texture on the fabric insert (premium tactile cue)
      '<line x1="25" y1="16" x2="25" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="32" y1="16" x2="32" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="40" y1="16" x2="40" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="48" y1="16" x2="48" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="55" y1="16" x2="55" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      // Curved bottom highlight (reflects light off the curve — premium cue)
      '<path d="M18 26 Q 40 28.5 62 26" stroke="#13548d" stroke-width="0.5" opacity=".35" fill="none"/>' +
      // Fabric below cassette (starts lower because cassette extends down)
      '<rect x="22" y="27" width="36" height="41" fill="url(#casFab)"/>' +
      '<line x1="29" y1="30" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="30" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="30" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>'
  };


  /* ============================================================
     STEP RENDERING
     ============================================================ */
  var stepsContainer = dom.qs('[data-builder-steps]');
  if (!stepsContainer) return;

  // Clear loading state
  stepsContainer.innerHTML = '';

  var STEPS = [
    { num: 1, title: 'Choose Openness', render: renderOpennessStep },
    { num: 2, title: 'Choose Color', render: renderColorStep },
    { num: 3, title: 'Choose Mount & Size', render: renderMountSizeStep },
    { num: 4, title: 'Choose Control Style', render: renderControlStep },
    { num: 5, title: 'Choose Roll Direction', render: renderRollStep },
    { num: 6, title: 'Choose Valance Options', render: renderValanceStep }
  ];

  var stepElements = [];

  // Build step DOM
  STEPS.forEach(function(step, idx) {
    var stepEl = dom.create('div', 'builder-v2__step' + (idx === 0 ? ' builder-v2__step--active' : ''));
    stepEl.setAttribute('data-step', step.num);

    var header = dom.create('div', 'builder-v2__step-header');
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
    header.setAttribute('aria-controls', 'builder-step-body-' + step.num);
    header.innerHTML =
      '<span class="builder-v2__step-num">' +
        '<span class="builder-v2__step-num__digit">' + step.num + '</span>' +
        '<svg class="builder-v2__step-num__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<polyline points="20 6 9 17 4 12"/>' +
        '</svg>' +
      '</span>' +
      '<span class="builder-v2__step-title">' + step.title + '</span>' +
      '<span class="builder-v2__step-selection" data-step-selection></span>' +
      '<svg class="builder-v2__step-chevron" viewBox="0 0 20 20" fill="none"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var body = dom.create('div', 'builder-v2__step-body');
    body.id = 'builder-step-body-' + step.num;
    var content = dom.create('div', 'builder-v2__step-content');
    body.appendChild(content);

    stepEl.appendChild(header);
    stepEl.appendChild(body);
    stepsContainer.appendChild(stepEl);

    stepElements.push({
      el: stepEl,
      content: content,
      selectionLabel: header.querySelector('[data-step-selection]')
    });

    // Render step content
    step.render(content);

    // Header click/keyboard → toggle
    dom.on(header, 'click', function() {
      toggleStep(idx);
    });
    dom.on(header, 'keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleStep(idx);
      }
    });
  });

  // Price bar stays hidden until bundle is ready (controlled by checkBundleReady)


  /* ============================================================
     STEP 1: CHOOSE OPENNESS
     Selects the solar fabric openness (1% or 3%). Switching openness:
       - Re-initializes the pricing engine with that openness group's
         price_tiers (different retail prices per openness)
       - Rebuilds the color step with that openness group's color_groups
         (same color names, different SKU prefixes: ECN1-xxx vs ECN3-xxx)
       - Resets downstream steps (size, control, etc.)
     The openness groups come from pricingData.openness[] in the metafield.
     ============================================================ */
  function renderOpennessStep(container) {
    var groups = pricingData && pricingData.openness;
    if (!groups || groups.length === 0) {
      container.innerHTML = '<p class="builder-v2__error builder-v2__error--visible">No openness options configured. Check the builder_pricing metafield.</p>';
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__openness-options');

    groups.forEach(function(group) {
      var card = dom.create('button', 'builder-v2__openness-btn');
      card.setAttribute('type', 'button');
      card.setAttribute('data-openness', group.id);
      card.innerHTML =
        '<span class="builder-v2__openness-pct">' + escapeHtml(group.label.replace(' Openness', '')) + '</span>' +
        '<span class="builder-v2__openness-label">Openness</span>';

      card._opennessData = group;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    // "Learn more" link below the openness buttons
    var learnDiv = dom.create('div', 'builder-v2__openness-learn');
    learnDiv.innerHTML =
      '<a href="#builder-v2-description" class="builder-v2__openness-learn-link">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>' +
        '</svg>' +
        'Learn how to choose your openness factor here' +
      '</a>';
    container.appendChild(learnDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__openness-btn', function() {
      var group = this._opennessData;
      if (!group) return;

      // Deactivate all
      dom.qsa('.builder-v2__openness-btn', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__openness-btn--active');
      });
      this.classList.add('builder-v2__openness-btn--active');

      store.set('openness', group.id);
      store.set('opennessLabel', group.label);

      // Clear size variant cache so parseSizeVariants picks the correct
      // size product for this openness level (different prices per %)
      _sizeVariantsCache = null;
      store.set('sizeVariantId', null);

      // Swap pricing engine to this openness group's data
      var swappedData = {};
      // Copy top-level keys (surcharges, valance, oversize)
      for (var key in pricingData) {
        if (key !== 'openness') swappedData[key] = pricingData[key];
      }
      // Override with openness-specific data
      swappedData.color_groups = group.color_groups;
      swappedData.price_tiers = group.price_tiers;

      // Re-init pricing engine
      pricing = new Core.PricingEngine(swappedData);

      // Reset color selection (different SKUs per openness)
      store.set('colorGroup', null);
      store.set('colorName', null);
      store.set('colorSku', null);
      store.set('colorImage', null);
      store.set('colorProductId', null);
      store.set('colorVariantId', null);

      // Rebuild color step swatches
      var colorContainer = stepElements[1].el.querySelector('.builder-v2__step-content');
      if (colorContainer) {
        colorContainer.innerHTML = '';
        renderColorStep(colorContainer);
      }

      // Clear downstream step completions
      for (var i = 1; i < stepElements.length; i++) {
        stepElements[i].el.classList.remove('builder-v2__step--complete');
        stepElements[i].selectionLabel.textContent = '';
      }

      stepElements[0].selectionLabel.textContent = group.label;
      completeStep(0);
      recalculatePrice();

      // Rebuild size dropdowns (price ranges may differ)
      events.emit('size:rebuild');
    });
  }


  /* ============================================================
     STEP 2: CHOOSE COLOR
     ============================================================ */
  function renderColorStep(container) {
    var colorBlock = findColorBlock();

    // Free Samples CTA — built first, but appended AFTER the swatches per
    // Warwick PDP review v2: "Please move the Free Sample CTA under the
    // color swatches rather than above, same as existing PDP." Matches the
    // proven placement in builder v1 where the prompt only appears once a
    // shopper has scanned the colors and is still hesitating.
    var sampleCta = dom.create('div', 'builder-v2__sample-cta-box');
    sampleCta.innerHTML =
      '<a href="/pages/free-samples-of-blinds-and-shades" class="builder-v2__sample-cta-link">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>' +
          '<polyline points="3.27 6.96 12 12.01 20.73 6.96"/>' +
          '<line x1="12" y1="22.08" x2="12" y2="12"/>' +
        '</svg>' +
        '<span>Order Free Samples</span>' +
      '</a>';

    // If we have pricing data with color groups, use that for grouping.
    // After openness selection, pricing.data has the swapped color_groups
    // for the selected openness level (e.g. econoscreen-3 for 3% openness).
    var activeColorGroups = pricing && pricing.data ? pricing.data.color_groups : null;
    if (activeColorGroups && activeColorGroups.length > 0) {
      activeColorGroups.forEach(function(group) {
        var groupDiv = dom.create('div', 'builder-v2__color-group');
        groupDiv.innerHTML = '<h4 class="builder-v2__color-group-label">' + escapeHtml(group.label) + '</h4>';

        var swatchesDiv = dom.create('div', 'builder-v2__swatches');

        group.colors.forEach(function(colorName) {
          var btn = dom.create('button', 'builder-v2__swatch');
          btn.setAttribute('type', 'button');
          btn.setAttribute('data-color', colorName);
          btn.setAttribute('data-group', group.id);

          // Find matching component product for image
          var image = '';
          var heroImage = '';
          var sku = (group.color_skus && group.color_skus[colorName]) || '';
          var productId = null;
          var variantId = null;

          if (colorBlock && colorBlock.products) {
            // Filter products to only those matching this openness group.
            // Group ID (e.g. "econoscreen-3") maps to handle prefix "color-econoscreen-3-".
            var groupIdLower = group.id.toLowerCase();
            var filteredProducts = [];
            for (var fi = 0; fi < colorBlock.products.length; fi++) {
              if (colorBlock.products[fi].handle && colorBlock.products[fi].handle.indexOf(groupIdLower) !== -1) {
                filteredProducts.push(colorBlock.products[fi]);
              }
            }

            // Match color name to filtered component product title.
            // Cascade: exact -> lowercase -> canonical "Color - {Name} ({Group})" pattern (bare
            // color or "{group.label} {color}" form). Substring match avoided because short
            // names like "Black" false-match other titles via group-suffix substrings (e.g.
            // "Almost White (7500 Blackout)" contains "black"). Canonical pass also tolerates
            // group-prefixed names ("Color - Genoa Chocolate" -> "Genoa Chocolate" matched
            // against group.label "Genoa" + " " + "Chocolate").
            var matchedProduct = null;
            var colorLower = colorName.trim().toLowerCase();
            for (var i = 0; i < filteredProducts.length; i++) {
              if (filteredProducts[i].title.trim() === colorName.trim()) {
                matchedProduct = filteredProducts[i];
                break;
              }
            }
            if (!matchedProduct) {
              for (var i = 0; i < filteredProducts.length; i++) {
                if (filteredProducts[i].title.trim().toLowerCase() === colorLower) {
                  matchedProduct = filteredProducts[i];
                  break;
                }
              }
            }
            if (!matchedProduct) {
              var canonicalTargets = [colorLower];
              if (group && group.label) {
                var labelLower = group.label.trim().toLowerCase();
                canonicalTargets.push(labelLower + ' ' + colorLower);
                var firstToken = labelLower.split(/\s+/)[0];
                if (firstToken && firstToken !== labelLower) {
                  canonicalTargets.push(firstToken + ' ' + colorLower);
                }
              }
              for (var i = 0; i < filteredProducts.length; i++) {
                var canonical = filteredProducts[i].title.match(/^\s*Color\s*-\s*(.+?)\s*\(/i);
                if (!canonical) continue;
                var extracted = canonical[1].trim().toLowerCase();
                if (canonicalTargets.indexOf(extracted) !== -1) {
                  matchedProduct = filteredProducts[i];
                  break;
                }
              }
            }
            if (matchedProduct) {
              image = matchedProduct.image || '';
              heroImage = matchedProduct.hero_image || '';
              productId = matchedProduct.id;
              if (matchedProduct.variants && matchedProduct.variants.length > 0) {
                variantId = matchedProduct.variants[0].id;
                if (!sku) sku = matchedProduct.variants[0].sku || '';
              }
            }
          }

          var initial = colorName.charAt(0).toUpperCase();
          var largeImage = image ? image.replace(/width=\d+/, 'width=600') : '';

          // Wrap swatch button + zoom in a container div (avoids nested buttons)
          var wrapper = dom.create('div', 'builder-v2__swatch-wrapper');
          btn.innerHTML =
            (image ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(image) + '" alt="' + escapeHtml(colorName) + '" loading="lazy">' :
              '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(initial) + '</span>') +
            '<span class="builder-v2__swatch-name">' + escapeHtml(colorName) + '</span>';

          wrapper.appendChild(btn);

          if (largeImage) {
            var zoomBtn = document.createElement('button');
            zoomBtn.type = 'button';
            zoomBtn.className = 'builder-v2__swatch-zoom';
            zoomBtn.setAttribute('data-large', largeImage);
            zoomBtn.setAttribute('data-name', colorName);
            zoomBtn.setAttribute('aria-label', 'Zoom ' + colorName);
            zoomBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';
            wrapper.appendChild(zoomBtn);
          }

          btn._colorData = {
            groupId: group.id,
            colorName: colorName,
            sku: sku,
            image: image,
            heroImage: heroImage,
            productId: productId,
            variantId: variantId
          };

          if (typeof SampleATC !== 'undefined' && SampleATC.enabled && sku) {
            SampleATC.attachButton(wrapper, sku, colorName);
          }

          swatchesDiv.appendChild(wrapper);
        });

        groupDiv.appendChild(swatchesDiv);
        container.appendChild(groupDiv);
      });

    } else if (colorBlock && colorBlock.products) {
      // Fallback: flat list from component products (no pricing groups)
      var swatchesDiv = dom.create('div', 'builder-v2__swatches');
      colorBlock.products.forEach(function(p) {
        var btn = dom.create('button', 'builder-v2__swatch');
        btn.setAttribute('type', 'button');
        btn.setAttribute('data-color', p.title);

        var variantId = p.variants && p.variants.length > 0 ? p.variants[0].id : null;
        var sku = p.variants && p.variants.length > 0 ? p.variants[0].sku : '';

        var pInitial = p.title.charAt(0).toUpperCase();
        var pLargeImage = p.image ? p.image.replace(/width=\d+/, 'width=600') : '';

        var wrapper = dom.create('div', 'builder-v2__swatch-wrapper');
        btn.innerHTML =
          (p.image ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' :
            '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(pInitial) + '</span>') +
          '<span class="builder-v2__swatch-name">' + escapeHtml(p.title) + '</span>';

        wrapper.appendChild(btn);

        if (pLargeImage) {
          var zoomBtn = document.createElement('button');
          zoomBtn.type = 'button';
          zoomBtn.className = 'builder-v2__swatch-zoom';
          zoomBtn.setAttribute('data-large', pLargeImage);
          zoomBtn.setAttribute('data-name', p.title);
          zoomBtn.setAttribute('aria-label', 'Zoom ' + p.title);
          zoomBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';
          wrapper.appendChild(zoomBtn);
        }

        btn._colorData = {
          groupId: null,
          colorName: p.title,
          sku: sku,
          image: p.image,
          heroImage: p.hero_image || '',
          productId: p.id,
          variantId: variantId
        };

        if (typeof SampleATC !== 'undefined' && SampleATC.enabled && sku) {
          SampleATC.attachButton(wrapper, sku, p.title);
        }

        swatchesDiv.appendChild(wrapper);
      });
      container.appendChild(swatchesDiv);
    }

    // Append Free Samples CTA UNDER the swatches per Warwick PDP review v2
    container.appendChild(sampleCta);

    // Event delegation for swatch clicks
    dom.on(container, 'click', '.builder-v2__swatch', function() {
      var data = this._colorData;
      if (!data) return;

      // Deactivate all swatches
      dom.qsa('.builder-v2__swatch', container).forEach(function(s) {
        s.classList.remove('builder-v2__swatch--active');
      });
      this.classList.add('builder-v2__swatch--active');

      // Update store
      store.set('colorGroup', data.groupId);
      store.set('colorName', data.colorName);
      store.set('colorSku', data.sku);
      store.set('colorImage', data.image);
      store.set('colorProductId', data.productId);
      store.set('colorVariantId', data.variantId);

      // Update pricing engine
      if (pricing && data.groupId) {
        pricing.setActiveGroup(data.groupId);
      }

      // Update step selection label
      stepElements[1].selectionLabel.textContent = data.colorName;

      // Emit for gallery swap
      events.emit('color:change', data);

      // Update URL with ?color= param for Google Shopping deep-linking.
      // Uses replaceState (not pushState) so back-button returns to
      // the previous page, not the previous color. Matches Blindster's
      // ?c= pattern. Feedoptimize reads these URLs for per-color
      // Shopping listings.
      if (history.replaceState && data.colorName) {
        var _url = new URL(window.location);
        _url.searchParams.set('color', data.colorName);
        history.replaceState(null, '', _url.toString());
      }

      // Mark complete + advance (index 1 = color step, after openness at 0)
      completeStep(1);
      recalculatePrice();

      // Rebuild size dropdowns if width range changed
      events.emit('size:rebuild');
    });

    // Swatch zoom lightbox (desktop only)
    injectSwatchZoomModal();
    dom.on(container, 'click', '.builder-v2__swatch-zoom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var largeUrl = this.getAttribute('data-large');
      var name = this.getAttribute('data-name');
      if (!largeUrl) return;
      openSwatchZoom(largeUrl, name);
    });
  }


  /* ============================================================
     STEP 2: CHOOSE MOUNT & SIZE
     ============================================================ */
  function renderMountSizeStep(container) {
    // Mount options — icon cards
    var mountDiv = dom.create('div', 'builder-v2__mount-options');
    mountDiv.innerHTML =
      '<button class="builder-v2__mount-option builder-v2__icon-card" data-mount="inside" type="button">' +
        '<span class="builder-v2__icon-card-icon">' + ICONS.insideMount + '</span>' +
        '<span class="builder-v2__icon-card-label">Inside Mount</span>' +
        '<span class="builder-v2__icon-card-desc">Fits inside the window recess</span>' +
      '</button>' +
      '<button class="builder-v2__mount-option builder-v2__icon-card" data-mount="outside" type="button">' +
        '<span class="builder-v2__icon-card-icon">' + ICONS.outsideMount + '</span>' +
        '<span class="builder-v2__icon-card-label">Outside Mount</span>' +
        '<span class="builder-v2__icon-card-desc">Mounts above or outside the frame</span>' +
      '</button>';
    container.appendChild(mountDiv);

    // Mount deduction notice
    var mountNotice = dom.create('div', 'builder-v2__mount-notice');
    mountNotice.style.display = 'none';
    container.appendChild(mountNotice);

    // Size inputs — preceded by a visual divider + "Enter Measurements"
    // heading with a "Help Me Measure" link, matching the SelectBlinds
    // pattern Warwick referenced in his PDP review.
    var sizeDiv = dom.create('div', 'builder-v2__size-area');
    sizeDiv.setAttribute('data-size-area', '');
    sizeDiv.style.display = 'none'; // hidden until mount selected
    // Mini measuring guide cards removed per Warwick PDP review v2:
    // "Remove the icons and short descriptions explaining Width and Height.
    // With the new more detailed Measure and Install section, we can direct
    // the customer to that part of the product page." The Measurement
    // information link below the inputs scrolls + opens that accordion.
    sizeDiv.innerHTML =
      '<div class="builder-v2__size-divider">' +
        '<h3 class="builder-v2__size-divider-title">Enter Measurements</h3>' +
      '</div>' +
      '<div class="builder-v2__size-row">' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label" for="bv2-width">Width</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" id="bv2-width" data-width-select aria-label="Width in inches"><option value="">Select width</option></select>' +
            '<select class="builder-v2__size-select builder-v2__size-select--fraction" data-width-frac aria-label="Width fraction"></select>' +
          '</div>' +
        '</div>' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label" for="bv2-height">Height</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" id="bv2-height" data-height-select aria-label="Height in inches"><option value="">Select height</option></select>' +
            '<select class="builder-v2__size-select builder-v2__size-select--fraction" data-height-frac aria-label="Height fraction"></select>' +
          '</div>' +
        '</div>' +
      '</div>' +
      // "Please follow our Measuring Guides..." tip — placed UNDER the
      // Width/Height inputs per Warwick PDP review v2: "Move the box
      // underneath the Width and Height inputs. At parity with current
      // product page." Old position (between illustrated cards and the
      // inputs) pushed the inputs too far down the fold.
      '<div class="builder-v2__measure-guide-tip">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#13548d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="3" y="3" width="18" height="18" rx="3"/>' +
          '<line x1="8" y1="12" x2="16" y2="12"/>' +
          '<line x1="12" y1="8" x2="12" y2="16"/>' +
        '</svg>' +
        '<span>Please review <a href="#builder-v2-measure-install" data-measure-info-link>Measurement information</a> for the best results. If you need a hand with the perfect fit, just reach out!</span>' +
      '</div>' +
      '<div class="builder-v2__room-name">' +
        '<label class="builder-v2__room-name-label" for="bv2-room-name">' +
          'Room Name <span class="builder-v2__room-name-optional">(Optional)</span>' +
        '</label>' +
        '<input type="text" class="builder-v2__room-name-input" id="bv2-room-name" ' +
          'data-room-name placeholder="Ex: West Wall" maxlength="20" autocomplete="off">' +
      '</div>' +
      // MeasureSafe upsell — reuses the existing measuresafe.css classes
      // that are already loaded sitewide on product pages. Exact same
      // markup as snippets/measuresafe-upsell.liquid so the visual is
      // identical to Builder 1.0.
      '<div class="measuresafe" data-measuresafe-upsell>' +
        '<label class="measuresafe__label">' +
          '<input type="checkbox" class="measuresafe__checkbox" id="bv2-measuresafe-checkbox" data-bv2-measuresafe>' +
          '<span class="measuresafe__checkmark"></span>' +
          '<div class="measuresafe__content">' +
            '<svg class="measuresafe__shield" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<path d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM10.94 15.54L7.4 12L8.81 10.59L10.93 12.71L15.17 8.47L16.58 9.88L10.94 15.54Z" fill="#13548d"/>' +
            '</svg>' +
            '<span class="measuresafe__title">MEASURESAFE\u2122 GUARANTEE</span>' +
            '<span class="measuresafe__price">+$9.99</span>' +
            '<button type="button" class="measuresafe__info-btn" data-bv2-measuresafe-tooltip-trigger aria-label="What is MeasureSafe?">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
                '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</label>' +
        '<div class="measuresafe__tagline">' +
          'Mismeasure? We\'ll remake it free. You only pay $20 shipping.' +
        '</div>' +
        '<div class="measuresafe__tooltip" data-bv2-measuresafe-tooltip aria-hidden="true">' +
          '<div class="measuresafe__tooltip-content">' +
            '<button type="button" class="measuresafe__tooltip-close" data-bv2-measuresafe-tooltip-close aria-label="Close">\u00d7</button>' +
            '<p class="measuresafe__tooltip-headline"><strong>Mistakes happen. Don\'t pay for them.</strong></p>' +
            '<p>With MeasureSafe\u2122, you\'re fully covered if your new blinds don\'t fit your window.</p>' +
            '<ul class="measuresafe__tooltip-list">' +
              '<li><strong>What we do:</strong> We\'ll remake your blinds at the correct size for free.</li>' +
              '<li><strong>Your cost:</strong> You only pay $20 shipping per remake item, and any price difference if the new blind is larger.</li>' +
            '</ul>' +
            '<a href="/pages/measuresafe-guarantee" class="measuresafe__tooltip-link" target="_blank" rel="noopener">' +
              'Learn more about MeasureSafe\u2122 \u2192' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    container.appendChild(sizeDiv);

    // Populate fraction selects
    var widthFrac = dom.qs('[data-width-frac]', sizeDiv);
    var heightFrac = dom.qs('[data-height-frac]', sizeDiv);
    populateFractionSelect(widthFrac);
    populateFractionSelect(heightFrac);

    // Room Name (optional) — store on blur/change so it's captured for cart
    var roomInput = dom.qs('[data-room-name]', sizeDiv);
    if (roomInput) {
      dom.on(roomInput, 'input', function() {
        store.set('roomName', this.value.trim());
      });
    }

    // MeasureSafe tooltip + checkbox
    var msCheckbox = dom.qs('[data-bv2-measuresafe]', sizeDiv);
    var msTrigger = dom.qs('[data-bv2-measuresafe-tooltip-trigger]', sizeDiv);
    var msTooltip = dom.qs('[data-bv2-measuresafe-tooltip]', sizeDiv);
    var msClose = dom.qs('[data-bv2-measuresafe-tooltip-close]', sizeDiv);

    if (msTrigger && msTooltip) {
      dom.on(msTrigger, 'click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        msTooltip.classList.toggle('is-visible');
        msTooltip.setAttribute('aria-hidden', !msTooltip.classList.contains('is-visible'));
      });
      if (msClose) {
        dom.on(msClose, 'click', function() {
          msTooltip.classList.remove('is-visible');
          msTooltip.setAttribute('aria-hidden', 'true');
        });
      }
    }
    if (msCheckbox) {
      dom.on(msCheckbox, 'change', function() {
        store.set('measuresafe', this.checked);
        recalculatePrice();
      });
    }

    // 2-Day Air shipping upgrade checkbox
    var shipCheckbox = dom.qs('[data-shipping-upgrade-checkbox]');
    if (shipCheckbox) {
      dom.on(shipCheckbox, 'change', function() {
        store.set('shippingUpgrade', this.checked);
        recalculatePrice();
      });
    }

    // Mount click
    dom.on(mountDiv, 'click', '.builder-v2__mount-option', function() {
      var mount = this.getAttribute('data-mount');
      dom.qsa('.builder-v2__mount-option', mountDiv).forEach(function(b) {
        b.classList.remove('builder-v2__mount-option--active');
        b.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__mount-option--active');
      this.classList.add('builder-v2__icon-card--active');
      store.set('mount', mount);
      sizeDiv.style.display = '';

      // Show mount-specific measurement notice (matches old builder's "Good to know" copy)
      var infoIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="flex-shrink:0"><circle cx="12" cy="12" r="11" stroke="#13548d" stroke-width="2" fill="none"/><text x="12" y="17" text-anchor="middle" font-size="14" font-weight="bold" fill="#13548d">i</text></svg>';
      if (mount === 'inside') {
        mountNotice.innerHTML =
          infoIcon +
          '<div><strong>Good to know</strong><br>To ensure a perfect fit, please provide the exact measurements of your window opening. Please do <strong>NOT</strong> deduct from these measurements or use the size of current blinds as a reference.</div>';
        mountNotice.style.display = '';
      } else {
        mountNotice.innerHTML =
          infoIcon +
          '<div><strong>Good to know</strong><br>Best for blackout and room darkening, outside mount blinds and shades are installed over the window on brackets attached to the wall or window frame. We suggest adding at least 4" to both your width and height measurements to help minimize light gaps around the edges.</div>';
        mountNotice.style.display = '';
      }

      rebuildSizeDropdowns();
    });

    // Width/Height change.
    // We update store + price immediately so the user sees live feedback.
    // Step 2 does NOT auto-advance to Step 3. It only marks itself complete
    // (green checkmark + selection summary in header) so the user knows
    // their measurements are locked in. The step stays open so they can
    // notice and fill the optional Room Name field below the dropdowns.
    // The user clicks Step 3's header themselves when ready to proceed.

    dom.on(sizeDiv, 'change', 'select', function() {
      var widthSel = dom.qs('[data-width-select]', sizeDiv);
      var heightSel = dom.qs('[data-height-select]', sizeDiv);
      var wFrac = dom.qs('[data-width-frac]', sizeDiv);
      var hFrac = dom.qs('[data-height-frac]', sizeDiv);

      var wInt = widthSel.value ? parseInt(widthSel.value, 10) : null;
      var hInt = heightSel.value ? parseInt(heightSel.value, 10) : null;
      var wf = parseFloat(wFrac.value) || 0;
      var hf = parseFloat(hFrac.value) || 0;

      store.set('widthInt', wInt);
      store.set('widthFrac', wf);
      store.set('heightInt', hInt);
      store.set('heightFrac', hf);

      if (wInt && hInt) {
        // Find matching size variant
        var actualWidth = fractions.combine(wInt, wf);
        var actualHeight = fractions.combine(hInt, hf);

        if (pricing && pricing.getActiveGroup()) {
          // Pricing engine path: round up to tier, find variant.
          // price_tiers can live inside the color group OR at root level
          // (mirrors getBasePrice logic in builder-core.js).
          var tiers = pricing.getActiveGroup().price_tiers || pricing.data.price_tiers;
          if (tiers) {
            var wTier = pricing.roundUpToTier(actualWidth, tiers.widths);
            var hTier = pricing.roundUpToTier(actualHeight, tiers.heights);
            // findSizeVariantId always falls back to a valid anchor
            // (parsed size variant -> raw first size variant -> parent),
            // so even if tier rounding fails the cart still gets an ID.
            var anchorTierW = wTier ? wTier.tier : 0;
            var anchorTierH = hTier ? hTier.tier : 0;
            store.set('sizeVariantId', findSizeVariantId(anchorTierW, anchorTierH));
          }
        } else {
          // Fallback path (no pricing data): find closest variant by rounding up
          var variants = parseSizeVariants();
          var bestVariant = null;
          var bestDiff = Infinity;
          for (var vi = 0; vi < variants.length; vi++) {
            var vw = variants[vi].width;
            var vh = variants[vi].height;
            if (vw >= actualWidth && vh >= actualHeight) {
              var diff = (vw - actualWidth) + (vh - actualHeight);
              if (diff < bestDiff) {
                bestDiff = diff;
                bestVariant = variants[vi];
              }
            }
          }
          // Same fallback chain if no closest variant found
          store.set('sizeVariantId', bestVariant ? bestVariant.id : findSizeVariantId(0, 0));
        }

        var displayW = fractions.formatDisplay(wInt, wf);
        var displayH = fractions.formatDisplay(hInt, hf);
        stepElements[2].selectionLabel.textContent =
          store.get('mount').charAt(0).toUpperCase() + store.get('mount').slice(1) +
          ' - ' + displayW + ' x ' + displayH;

        // Live price feedback every change
        recalculatePrice();

        // Mark Step 2 complete (green check + summary) but do NOT
        // auto-collapse or auto-open Step 3. The step stays open so the
        // user can fill Room Name before proceeding.
        stepElements[2].el.classList.add('builder-v2__step--complete');
        checkBundleReady();
      }
    });

    // Listen for size rebuild (when color group changes max width)
    events.on('size:rebuild', function() {
      if (store.get('mount')) rebuildSizeDropdowns();
    });

    function rebuildSizeDropdowns() {
      var widthSel = dom.qs('[data-width-select]', sizeDiv);
      var heightSel = dom.qs('[data-height-select]', sizeDiv);
      if (!widthSel || !heightSel) return;

      var widthRange, heightRange;

      if (pricing && pricing.getActiveGroup()) {
        var r = pricing.getWidthRange();
        widthRange = range(r.minWidth, r.maxWidth);
        heightRange = range(r.minHeight, r.maxHeight);
      } else {
        var variants = parseSizeVariants();
        var widths = [], heights = [];
        variants.forEach(function(v) {
          if (widths.indexOf(v.width) === -1) widths.push(v.width);
          if (heights.indexOf(v.height) === -1) heights.push(v.height);
        });
        widths.sort(function(a,b) { return a - b; });
        heights.sort(function(a,b) { return a - b; });
        if (widths.length >= 2) widthRange = range(widths[0], widths[widths.length - 1]);
        else widthRange = widths;
        if (heights.length >= 2) heightRange = range(heights[0], heights[heights.length - 1]);
        else heightRange = heights;
      }

      // Preserve current selection if still valid
      var currentW = store.get('widthInt');
      var currentH = store.get('heightInt');

      populateSelect(widthSel, widthRange, 'Select width', currentW);
      populateSelect(heightSel, heightRange, 'Select height', currentH);

      // Clear selection if out of range and invalidate step 2 completion
      var invalidated = false;
      if (currentW && widthRange.indexOf(currentW) === -1) {
        store.set('widthInt', null);
        store.set('sizeVariantId', null);
        widthSel.value = '';
        invalidated = true;
      }
      if (currentH && heightRange.indexOf(currentH) === -1) {
        store.set('heightInt', null);
        store.set('sizeVariantId', null);
        heightSel.value = '';
        invalidated = true;
      }
      if (invalidated) {
        // Remove completed state from step 2 and all downstream steps
        for (var si = 1; si < stepElements.length; si++) {
          stepElements[si].el.classList.remove('builder-v2__step--complete');
          stepElements[si].selectionLabel.textContent = '';
        }
        // Reset downstream store values
        store.set('control', null);
        store.set('controlLabel', null);
        store.set('controlSurcharge', 0);
        store.set('rollDirection', null);
        store.set('valanceType', null);
        store.set('valanceLabel', null);
        store.set('valancePrice', 0);
        // Deactivate downstream option/icon cards
        for (var si = 2; si < stepElements.length; si++) {
          dom.qsa('.builder-v2__icon-card--active', stepElements[si].content).forEach(function(c) {
            c.classList.remove('builder-v2__icon-card--active');
          });
        }
        // Re-check bundle readiness (will disable ATC)
        checkBundleReady();
        recalculatePrice();
      }
    }
  }


  /* ============================================================
     STEP 3: CHOOSE CONTROL STYLE
     ============================================================ */
  // Motorization eligibility comes from a Liquid-rendered flag in the
  // JSON bridge (server-side, no CDN). Add the tag "motorized" to any
  // product in Shopify Admin to enable. Per Warwick: only available on
  // Signature LF, Signature Sheer LF, Luxe Natural LF.
  var motorizedAllowed = !!parentData.motorized_enabled;

  function renderControlStep(container) {
    var options = [
      { value: 'plastic-chain-left', label: 'Plastic Chain', desc: 'Left Side', icon: ICONS.chainLeft, surcharge: 0, surchargeKey: null },
      { value: 'plastic-chain-right', label: 'Plastic Chain', desc: 'Right Side', icon: ICONS.chainRight, surcharge: 0, surchargeKey: null },
      { value: 'stainless-chain-left', label: 'Metal Chain', desc: 'Left Side', icon: ICONS.chainLeft, surcharge: 0, surchargeKey: 'stainless_chain' },
      { value: 'stainless-chain-right', label: 'Metal Chain', desc: 'Right Side', icon: ICONS.chainRight, surcharge: 0, surchargeKey: 'stainless_chain' },
      { value: 'cordless', label: 'Deluxe Cordless', desc: 'Child-safe, no cords', icon: ICONS.cordless, surcharge: 0, surchargeKey: 'cordless' },
      { value: 'motorized', label: 'Motorized', desc: 'Remote control operation', icon: ICONS.cordless, surcharge: 0, surchargeKey: 'motorized' }
    ];

    options.forEach(function(opt) {
      if (opt.surchargeKey && pricing) {
        opt.surcharge = pricing.getSurcharge(opt.surchargeKey);
      }
    });

    var optionsDiv = dom.create('div', 'builder-v2__icon-grid');

    options.forEach(function(opt) {

      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-control', opt.value);

      var priceBadge = opt.surcharge > 0
        ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(opt.surcharge) + '</span>'
        : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';

      card.innerHTML =
        priceBadge +
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._controlData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    // Motorized visibility is handled by Liquid CSS in the section file
    // (not JS) to avoid Shopify minifier issues. See product-template-builder-v2.liquid.

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // Block clicks on disabled cards (motorization size-locked)
      if (this.hasAttribute('disabled')) return;

      var data = this._controlData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      store.set('control', data.value);
      store.set('controlLabel', data.label + (data.desc ? ' - ' + data.desc : ''));
      store.set('controlSurcharge', data.surcharge);

      stepElements[3].selectionLabel.textContent = data.label;
      completeStep(3);
      recalculatePrice();

      // Trigger valance lock check (motorized → no valance)
      enforceValanceLock();
    });

    // Size restriction: disable motorization when width or height > 72".
    // Uses integer part only (not fractions) because in the blinds
    // industry "72 inches" includes 72 0/8 through 72 7/8. A customer
    // selecting 72 3/8" is still ordering a "72-inch blind".
    // Always subscribe -- checks for the DOM element directly
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt') return;
        var motorCard = dom.qs('[data-control="motorized"]', optionsDiv);
        if (!motorCard) return;

        var wInt = store.get('widthInt') || 0;
        var hInt = store.get('heightInt') || 0;
        var oversized = wInt > 72 || hInt > 72;

        if (oversized) {
          motorCard.classList.add('builder-v2__icon-card--disabled');
          motorCard.setAttribute('disabled', 'disabled');
          // If motorized was already selected, reset control style
          if (store.get('control') === 'motorized') {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            motorCard.classList.remove('builder-v2__icon-card--active');
            stepElements[3].el.classList.remove('builder-v2__step--complete');
            stepElements[3].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        } else {
          motorCard.classList.remove('builder-v2__icon-card--disabled');
          motorCard.removeAttribute('disabled');
        }
      });
    }

    // Deluxe Cordless dimension gate. Per Mariak account rep request
    // (Warwick, 2026-05-13): Deluxe Cordless on Mariak Builder 2.0
    // products is only available within the per-parent cordless_spec
    // window written to custom.builder_pricing. Mirrors the cordless
    // gate already in builder-roller-v2.js. When the metafield omits
    // cordless_spec, the gate is a no-op (legacy default).
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt') return;
        var cordlessSpec = pricingData && pricingData.cordless_spec;
        if (!cordlessSpec) return;
        var cordlessCard = dom.qs('[data-control="cordless"]', optionsDiv);
        if (!cordlessCard) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        var outOfRange = (wInt && (wInt < cordlessSpec.min_w || wInt > cordlessSpec.max_w))
                      || (hInt && (hInt < cordlessSpec.min_h || hInt > cordlessSpec.max_h));

        if (outOfRange) {
          cordlessCard.classList.add('builder-v2__icon-card--disabled');
          cordlessCard.setAttribute('disabled', 'disabled');
          cordlessCard.setAttribute('aria-disabled', 'true');
          if (store.get('control') === 'cordless') {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            cordlessCard.classList.remove('builder-v2__icon-card--active');
            stepElements[3].el.classList.remove('builder-v2__step--complete');
            stepElements[3].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        } else {
          cordlessCard.classList.remove('builder-v2__icon-card--disabled');
          cordlessCard.removeAttribute('disabled');
          cordlessCard.removeAttribute('aria-disabled');
        }
      });
    }
  }


  /* ============================================================
     STEP 4: CHOOSE ROLL DIRECTION
     ============================================================ */
  function renderRollStep(container) {
    var options = [
      { value: 'standard', label: 'Standard Roll', desc: 'Fabric rolls behind the tube, closer to window', icon: ICONS.standardRoll },
      { value: 'reverse', label: 'Reverse Roll', desc: 'Fabric rolls in front of the tube (waterfall)', icon: ICONS.reverseRoll }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-roll', opt.value);
      card.innerHTML =
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._rollData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._rollData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      store.set('rollDirection', data.value);
      stepElements[4].selectionLabel.textContent = data.label;
      completeStep(4);

      // Trigger valance lock check (reverse roll → no valance)
      enforceValanceLock();
    });
  }


  /* ============================================================
     VALANCE LOCK. Disables Fascia/Cassette when an incompatible
     roll direction or control style is selected. Called after
     roll direction or control style changes. If the user already
     picked a now-locked option, auto-resets to No Valance and
     recalculates the price.

     Compatibility matrix (Warwick EDI requirements):
       Fascia:   incompatible with Cordless (mechanism does not
                 fit behind a fascia) and with Reverse Roll (the
                 waterfall fabric drops in front of the tube and
                 a flat fascia blocks it).
       Cassette: incompatible with Reverse Roll and Motorized.
     ============================================================ */
  function enforceValanceLock() {
    var isReverse = store.get('rollDirection') === 'reverse';
    var isMotorized = store.get('control') === 'motorized';
    var isCordless = store.get('control') === 'cordless';

    var fasciaLocked = isCordless || isReverse;
    // Cassette: NOT available with reverse roll or motorized
    var cassetteLocked = isReverse || isMotorized;

    var fasciaCard = dom.qs('[data-valance="fascia"]');
    var cassetteCard = dom.qs('[data-valance="cassette"]');

    if (fasciaCard) {
      if (fasciaLocked) {
        fasciaCard.classList.add('builder-v2__icon-card--disabled');
        fasciaCard.setAttribute('disabled', 'disabled');
      } else {
        fasciaCard.classList.remove('builder-v2__icon-card--disabled');
        fasciaCard.removeAttribute('disabled');
      }
    }
    if (cassetteCard) {
      if (cassetteLocked) {
        cassetteCard.classList.add('builder-v2__icon-card--disabled');
        cassetteCard.setAttribute('disabled', 'disabled');
      } else {
        cassetteCard.classList.remove('builder-v2__icon-card--disabled');
        cassetteCard.removeAttribute('disabled');
      }
    }

    // If the currently selected valance is now locked, reset to No Valance
    var currentValance = store.get('valanceType');
    var needsReset = (currentValance === 'fascia' && fasciaLocked) ||
                     (currentValance === 'cassette' && cassetteLocked) ||
                     (currentValance === 'cassette-fabric' && cassetteLocked);
    if (needsReset) {
      store.set('valanceType', null);
      store.set('valanceLabel', 'No Valance');
      store.set('valancePrice', 0);

      dom.qsa('[data-valance]').forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      var noValCard = dom.qs('[data-valance="none"]');
      if (noValCard) noValCard.classList.add('builder-v2__icon-card--active');

      stepElements[5].selectionLabel.textContent = 'No Valance';
      recalculatePrice();
    }
  }


  /* ============================================================
     STEP 5: CHOOSE VALANCE OPTIONS
     ============================================================ */
  function renderValanceStep(container) {
    var optionsDiv = dom.create('div', 'builder-v2__icon-grid builder-v2__icon-grid--3');
    optionsDiv.setAttribute('data-valance-options', '');

    var options = [
      { value: null, label: 'No Valance', desc: 'Standard open roller', icon: ICONS.noValance, addonType: null },
      { value: 'fascia', label: 'Aluminum Fascia (White)', desc: 'Clean rectangular cover', icon: ICONS.fascia, addonType: 'fascia' },
      { value: 'cassette', label: 'Cassette w/ Fabric', desc: 'Curved cover with fabric insert', icon: ICONS.cassette, addonType: 'cassette' }
    ];

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-valance', opt.value || 'none');

      var priceBadge = '';
      if (opt.addonType) {
        priceBadge = '<span class="builder-v2__icon-card-badge" data-valance-price="' + opt.addonType + '">+$0.00</span>';
      } else {
        priceBadge = '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
      }

      card.innerHTML =
        priceBadge +
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._valanceData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    // Click handler
    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // Block clicks on disabled cards (locked by reverse roll / motorized)
      if (this.hasAttribute('disabled')) return;

      var data = this._valanceData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      var price = 0;
      if (data.addonType && pricing) {
        var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
        price = pricing.getAddonPrice(data.addonType, w);
      }

      store.set('valanceType', data.value);
      store.set('valanceLabel', data.label);
      store.set('valancePrice', price);

      stepElements[5].selectionLabel.textContent = data.label;
      completeStep(5);
      recalculatePrice();
    });

    // Update valance prices when width changes
    store.subscribe(function(key) {
      if (key === 'widthInt' || key === 'widthFrac') {
        updateValancePrices();
        // Recalc selected valance price
        var currentType = store.get('valanceType');
        if (currentType && pricing) {
          var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
          store.set('valancePrice', pricing.getAddonPrice(currentType, w));
        }
      }
    });

    function updateValancePrices() {
      var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
      if (!w || !pricing) return;
      dom.qsa('[data-valance-price]', optionsDiv).forEach(function(el) {
        var type = el.getAttribute('data-valance-price');
        var price = pricing.getAddonPrice(type, w);
        el.textContent = '+' + Core.formatMoney(price);
      });
    }
  }


  /* ============================================================
     STEP NAVIGATION (ACCORDION)
     ============================================================ */
  function toggleStep(idx) {
    var stepEl = stepElements[idx].el;
    var isActive = stepEl.classList.contains('builder-v2__step--active');
    var isComplete = stepEl.classList.contains('builder-v2__step--complete');

    // Block clicking incomplete future steps (only allow completed or active)
    if (!isActive && !isComplete) {
      // Check if all previous steps are complete
      var allPrevComplete = true;
      for (var i = 0; i < idx; i++) {
        if (!stepElements[i].el.classList.contains('builder-v2__step--complete')) {
          allPrevComplete = false;
          break;
        }
      }
      if (!allPrevComplete) return;
    }

    // Toggle this step only. Do not auto-collapse other steps and do
    // not auto-scroll. Per Warwick: customers should keep prior steps
    // open so they can review their measurements and earlier choices
    // while picking the next option, without the page jumping. They
    // can close any step manually by clicking its header again.
    var header = stepEl.querySelector('.builder-v2__step-header');
    if (isActive) {
      stepEl.classList.remove('builder-v2__step--active');
      if (header) header.setAttribute('aria-expanded', 'false');
    } else {
      stepEl.classList.add('builder-v2__step--active');
      if (header) header.setAttribute('aria-expanded', 'true');
    }
  }

  function completeStep(idx) {
    stepElements[idx].el.classList.add('builder-v2__step--complete');
    // No auto-advance to next step. User clicks the next step header
    // manually. Per Warwick: auto-jump pushes users down the page
    // before they're ready (especially on mobile) and prevents
    // browsing colors with the gallery image swap.
    checkBundleReady();
  }


  /* ============================================================
     PRICE RECALCULATION
     ============================================================ */
  function recalculatePrice() {
    var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
    var h = fractions.combine(store.get('heightInt'), store.get('heightFrac'));

    var base = 0;
    if (w && h) {
      if (pricing && pricing.getActiveGroup()) {
        // Pricing engine: use WxH matrix
        base = pricing.getBasePrice(w, h);
        if (base === null) base = 0;
      } else {
        // Fallback: use variant price from the matched size variant
        var variantId = store.get('sizeVariantId');
        if (variantId) {
          var variants = parseSizeVariants();
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === variantId) {
              base = variants[i].price;
              break;
            }
          }
        }
      }
    }

    store.set('basePrice', base);

    var surcharge = store.get('controlSurcharge') || 0;
    var valance = store.get('valancePrice') || 0;
    var oversize = (pricing && w) ? pricing.getOversizeSurcharge(w) : 0;
    store.set('oversizeSurcharge', oversize);

    var total = pricing
      ? pricing.calculateTotal({ basePrice: base, controlSurcharge: surcharge, valancePrice: valance, oversizeSurcharge: oversize })
      : Math.round((base + surcharge + valance + oversize) * 100) / 100;

    // MeasureSafe is a separate cart line, but include in display total
    // so the price the customer sees matches what they'll pay at checkout.
    // Matches old builder pattern (product-builder.js:2071-2073).
    var msPrice = store.get('measuresafe') ? 9.99 : 0;
    var shipPrice = store.get('shippingUpgrade') ? 40 : 0;
    var totalWithAddons = Math.round((total + msPrice + shipPrice) * 100) / 100;
    store.set('totalPrice', total); // store raw total WITHOUT MeasureSafe for cart line

    // Update DOM — show per-unit and total with qty multiplier
    var qty = store.get('quantity') || 1;
    var lineTotal = Math.round(totalWithAddons * qty * 100) / 100;

    var priceEl = dom.qs('[data-total-price]');
    if (priceEl) priceEl.textContent = Core.formatMoney(lineTotal);

    var perUnitEl = dom.qs('[data-price-per-unit]');
    if (perUnitEl) {
      perUnitEl.textContent = qty > 1 ? '(' + qty + ' x ' + Core.formatMoney(total) + ' each)' : '';
    }

    var displayEl = dom.qs('[data-price-value]');
    if (displayEl && total > 0) {
      // Top "Starting at" mirrors per-shade total + per-shade addons
      // (MeasureSafe, 2-Day Air upgrade) so it visibly agrees with the
      // bottom Your Price at qty=1. Quantity multiplier stays line-level.
      // The Spend & Save card is the headline price, so it follows the quantity like the bar total.
      var topAmount = ssMode ? lineTotal : totalWithAddons;
      displayEl.textContent = Core.formatMoney(topAmount);
      if (ssMode) syncSsAffirm(topAmount);
    }
    // Once a real size is priced, the top label names that size instead of the starting one.
    var sizeLabelEl = dom.qs('[data-price-size]');
    if (sizeLabelEl && displayEl && total > 0 && base > 0) {
      sizeLabelEl.textContent = 'for ' + (ssMode && qty > 1 ? qty + ' at ' : '') + fractions.formatDisplay(store.get('widthInt'), store.get('widthFrac')) +
        ' x ' + fractions.formatDisplay(store.get('heightInt'), store.get('heightFrac'));
      var fromLabelEl = dom.qs('[data-price-from]');
      if (fromLabelEl) fromLabelEl.hidden = true;
    }

    // Compare At MSRP. Multiplier comes from the parent product's
    // compare_at_price / price ratio. Builder applies that ratio to the
    // calculated total so the strikethrough scales with size and options.
    renderMsrp('top', total);
    renderMsrp('bottom', lineTotal);

    // Mobile sticky ATC price
    var atcPriceEl = dom.qs('[data-atc-price]');
    if (atcPriceEl) {
      atcPriceEl.textContent = lineTotal > 0 ? Core.formatMoney(lineTotal) : '';
    }

    // Show price bar as soon as we have any calculated price (not waiting for all steps)
    var priceBar = dom.qs('[data-price-bar]');
    if (priceBar) {
      priceBar.style.display = (base > 0) ? '' : 'none';
    }

    // Show 2-Day Air upgrade once price is visible
    var shipUpgradeEl = dom.qs('[data-shipping-upgrade]');
    if (shipUpgradeEl) {
      shipUpgradeEl.style.display = (base > 0) ? '' : 'none';
    }

    events.emit('price:update', { base: base, total: total });
  }


  /* ============================================================
     BUNDLE READINESS CHECK
     ============================================================ */
  var wasReady = false;
  function checkBundleReady() {
    // All 5 steps must be completed
    var allComplete = true;
    for (var i = 0; i < stepElements.length; i++) {
      if (!stepElements[i].el.classList.contains('builder-v2__step--complete')) {
        allComplete = false;
        break;
      }
    }

    // Must also have a valid size variant.
    // Safety net: if every step is complete but no anchor variant has been
    // resolved (edge case where the size block has no usable products and
    // the tier lookup never ran), force-set the parent product variant as
    // the cart anchor. The anchor is just a placeholder - the real price
    // and dimensions ride on line item properties for LogicBroker EDI.
    if (allComplete && !store.get('sizeVariantId') && parentData && parentData.variant_id) {
      console.warn('[BuilderRoller] No size variant resolved - using parent variant as anchor');
      store.set('sizeVariantId', parentData.variant_id);
    }
    var hasVariant = !!store.get('sizeVariantId');
    var ready = allComplete && hasVariant;

    var atcBtn = dom.qs('[data-atc-btn]');
    if (atcBtn) {
      atcBtn.disabled = !ready;
      if (ready) {
        var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Add to Cart';
      } else {
        // Find first incomplete step to guide the customer
        var nextStep = '';
        for (var j = 0; j < stepElements.length; j++) {
          if (!stepElements[j].el.classList.contains('builder-v2__step--complete')) {
            nextStep = STEPS[j].title;
            break;
          }
        }
        var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = nextStep ? 'Complete: ' + nextStep : 'Add to Cart';
      }

      // Task 5f: one-time attention pulse on the false→true transition.
      // Triggers only when the user just finished the last step and the
      // button becomes actionable, never on subsequent recalcs.
      if (ready && !wasReady) {
        var reduceMotion = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduceMotion) {
          atcBtn.classList.add('builder-v2__atc-btn--ready');
          setTimeout(function() {
            atcBtn.classList.remove('builder-v2__atc-btn--ready');
          }, 600);
        }
      }
    }
    wasReady = ready;

    if (ready) {
      events.emit('bundle:ready', { valid: true });
    }
  }


  /* ============================================================
     ADD TO CART
     ============================================================ */
  var atcBtn = dom.qs('[data-atc-btn]');
  if (atcBtn) {
    dom.on(atcBtn, 'click', function() {
      if (atcBtn.disabled) return;

      var state = store.get();
      var timestamp = Core.Cart.generateTimestamp();

      // Find size variant
      var sizeVariantId = state.sizeVariantId;
      if (!sizeVariantId) {
        showError('Could not find matching size variant. Please adjust your dimensions.');
        return;
      }

      // Build display strings
      var widthDisplay = fractions.formatDisplay(state.widthInt, state.widthFrac);
      var heightDisplay = fractions.formatDisplay(state.heightInt, state.heightFrac);

      // Collect child items
      // Each component with a surcharge is added as a child line item with its
      // own Shopify variant at the correct price. This ensures Shopify checkout
      // charges the correct total (sum of variant prices = _BundleSubtotal).
      var childItems = [];
      var childVariantIds = [];
      var childBundleProps = {
        'Bundle': parentData.title,
        '_BundleHandle': parentData.handle,
        '_Timestamp': timestamp
      };

      // Charge an exact surcharge amount as one or more bundle child lines.
      // Prefer the dedicated mapped variant (also the EDI marker); when no variant
      // is mapped for this exact amount, fall back to the $1 + $0.01 denomination
      // variants so the surcharge shown on the PDP and cart is actually collected
      // at checkout instead of silently dropping.
      // denomDollar/denomPenny route the denomination fallback to a type-named
      // product so the checkout line reads by type (Warwick 2026-07-11).
      // One child line per non-zero digit ($100 + $70 + $3 + $0.90 + $0.08) so a
      // surcharge is a handful of single items, not hundreds of $1/$0.01 units.
      function splitDigits(cents, map) {
        if (!map || !(cents > 0)) return null;
        var out = [], top = Math.floor(cents / 100000), rest = cents % 100000;
        if (top > 0) {
          if (top <= 9 && map[top * 100000]) out.push([map[top * 100000], 1, top * 100000]);
          else if (map[100000]) out.push([map[100000], top, 100000]);
          else return null;
        }
        var places = [10000, 1000, 100, 10, 1];
        for (var i = 0; i < places.length; i++) {
          var d = Math.floor(rest / places[i]) % 10;
          if (!d) continue;
          if (!map[d * places[i]]) return null;
          out.push([map[d * places[i]], 1, d * places[i]]);
        }
        var sum = 0;
        for (var j = 0; j < out.length; j++) sum += out[j][1] * out[j][2];
        return sum === cents ? out : null;
      }

      function pushSurchargeChild(mappedVariantId, amountDollars, label, denomDollar, denomPenny) {
        if (mappedVariantId) {
          childItems.push({ variantId: mappedVariantId, quantity: state.quantity, properties: childBundleProps });
          childVariantIds.push(mappedVariantId);
          return;
        }
        if (!(amountDollars > 0)) return;
        var cents = Math.round(amountDollars * 100);
        var dollarUnits = Math.floor(cents / 100);
        var centUnits = cents % 100;
        var dVar = denomDollar || (surchargeVariants && surchargeVariants.dollar);
        var pVar = denomPenny || (surchargeVariants && surchargeVariants.penny);
        var digitLines = splitDigits(cents, surchargeVariants && surchargeVariants.digits && surchargeVariants.digits[dVar]);
        if (digitLines) {
          for (var di = 0; di < digitLines.length; di++) {
            childItems.push({ variantId: digitLines[di][0], quantity: digitLines[di][1] * state.quantity, properties: childBundleProps });
            childVariantIds.push(digitLines[di][0]);
          }
          return;
        }
        if (dollarUnits > 0 && dVar) {
          childItems.push({ variantId: dVar, quantity: dollarUnits * state.quantity, properties: childBundleProps });
          childVariantIds.push(dVar);
        }
        if (centUnits > 0 && pVar) {
          childItems.push({ variantId: pVar, quantity: centUnits * state.quantity, properties: childBundleProps });
          childVariantIds.push(pVar);
        }
        if ((dollarUnits > 0 && !dVar) || (centUnits > 0 && !pVar)) {
          console.warn('[BuilderSolar] ' + (label || 'surcharge') + ' $' + amountDollars.toFixed(2) +
            ' has no mapped variant and no $1/$0.01 denomination variant; bundle would undercharge.');
        }
      }

      // Color as child (component product from collection, priced at $0)
      if (state.colorVariantId) {
        childItems.push({
          variantId: state.colorVariantId,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(state.colorVariantId);
      }

      // Control style surcharge as child
      // Price-based lookup: works for both roller and solar surcharge amounts
      if (surchargeVariants && state.controlSurcharge > 0 && surchargeVariants.control) {
        var controlPriceKey = state.controlSurcharge.toFixed(2);
        pushSurchargeChild(surchargeVariants.control[controlPriceKey], state.controlSurcharge, 'control surcharge',
          surchargeVariants.controlDollar, surchargeVariants.controlPenny);
      }

      // Valance surcharge as child
      if (surchargeVariants && state.valancePrice > 0) {
        var valanceType = (state.valanceType === 'cassette' || state.valanceType === 'cassette-fabric') ? 'cassette' : 'fascia';
        var valancePriceKey = state.valancePrice.toFixed(2);
        var valanceMap = surchargeVariants[valanceType];
        pushSurchargeChild(valanceMap && valanceMap[valancePriceKey], state.valancePrice, 'valance surcharge (' + valanceType + ')',
          surchargeVariants.valanceDollar, surchargeVariants.valancePenny);
      }

      // Oversize surcharge as child
      if (surchargeVariants && state.oversizeSurcharge > 0 && surchargeVariants.oversize) {
        childItems.push({
          variantId: surchargeVariants.oversize,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(surchargeVariants.oversize);
      }

      // 2-Day Air shipping upgrade as child ($40 flat)
      if (surchargeVariants && state.shippingUpgrade && surchargeVariants.shipping) {
        childItems.push({
          variantId: surchargeVariants.shipping,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(surchargeVariants.shipping);
      }

      // Build parent properties (EDI-compatible keys)
      // Property key names read from block config to match what LogicBroker transforms expect.
      var mountKey = getBlockPropertyKey('Mount', 'Mount Type');
      var bundleIds = Core.Cart.buildBundleIds(sizeVariantId, childVariantIds);
      var bundleTotal = state.shippingUpgrade ? state.totalPrice + 40 : state.totalPrice;
      var parentProps = {
        'Bundle': parentData.title,
        '_BundleHandle': parentData.handle,
        '_BundleImg': parentData.featured_image || '',
        '_Timestamp': timestamp,
        '_BundleIds': bundleIds,
        '_BundleSubtotal': bundleTotal.toFixed(2),
        '_BundleCompareSubtotal': (msrpMultiplier > 0 ? Math.round(bundleTotal * msrpMultiplier * 100) / 100 : bundleTotal).toFixed(2),
        '_colorCode': state.colorSku || '',
        'Width': widthDisplay,
        'Height': heightDisplay,
        'Control Style': state.controlLabel || '',
        'Roll Direction': state.rollDirection === 'standard' ? 'Standard Roll' : 'Reverse Roll',
        'Valance': state.valanceLabel || 'None',
        'Openness': state.opennessLabel || ''
      };
      parentProps[mountKey] = state.mount === 'inside' ? 'Inside Mount' : 'Outside Mount';
      if (state.roomName) {
        parentProps['Room Name'] = state.roomName;
      }
      if (state.shippingUpgrade) {
        parentProps['_ShippingUpgrade'] = '2 Day Air';
        parentProps['Shipping'] = '2-Day Air (+$40.00)';
      }

      var parentItem = {
        variantId: sizeVariantId,
        quantity: state.quantity,
        properties: parentProps
      };

      // Set loading state
      atcBtn.classList.add('builder-v2__atc-btn--loading');
      var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Adding to Cart...';
      atcBtn.disabled = true;

      // MeasureSafe: queue as standalone cart line AFTER the bundle,
      // matching old builder pattern (product-builder.js:4031-4054).
      // NOT part of _BundleIds — separate add-on.
      var msItem = null;
      if (state.measuresafe) {
        msItem = {
          variantId: '55217671340200', // live MeasureSafe variant ID
          quantity: state.quantity,
          properties: {
            'Protected Product': parentData.title,
            'Protected Size': widthDisplay + ' x ' + heightDisplay
          }
        };
      }

      Core.Cart.addBundle(parentItem, childItems, { redirect: true, addonItem: msItem })
        .catch(function(err) {
          atcBtn.classList.remove('builder-v2__atc-btn--loading');
          var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          showError('Error adding to cart. Please try again.');
        });
    });
  }


  /* ============================================================
     QUANTITY CONTROLS
     ============================================================ */
  var qtyMinus = dom.qs('[data-qty-minus]');
  var qtyPlus = dom.qs('[data-qty-plus]');
  var qtyInput = dom.qs('[data-qty-input]');

  if (qtyMinus && qtyPlus && qtyInput) {
    dom.on(qtyMinus, 'click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        store.set('quantity', val - 1);
        recalculatePrice();
      }
    });

    dom.on(qtyPlus, 'click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      store.set('quantity', val + 1);
      recalculatePrice();
    });

    dom.on(qtyInput, 'change', function() {
      var val = parseInt(this.value, 10);
      if (!val || val < 1) val = 1;
      this.value = val;
      store.set('quantity', val);
      recalculatePrice();
    });
  }


  /* ============================================================
     SWATCH ZOOM LIGHTBOX (desktop only)
     ============================================================ */
  function injectSwatchZoomModal() {
    if (document.getElementById('builder-v2-swatch-zoom')) return;
    var modal = document.createElement('div');
    modal.id = 'builder-v2-swatch-zoom';
    modal.className = 'builder-v2__zoom-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Color swatch zoom');
    modal.innerHTML =
      '<div class="builder-v2__zoom-backdrop"></div>' +
      '<div class="builder-v2__zoom-content">' +
        '<button class="builder-v2__zoom-close" type="button" aria-label="Close">&times;</button>' +
        '<img class="builder-v2__zoom-img" src="" alt="" />' +
        '<p class="builder-v2__zoom-name"></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('.builder-v2__zoom-close').addEventListener('click', closeSwatchZoom);
    modal.querySelector('.builder-v2__zoom-backdrop').addEventListener('click', closeSwatchZoom);
  }

  function openSwatchZoom(imageUrl, colorName) {
    var modal = document.getElementById('builder-v2-swatch-zoom');
    if (!modal) return;
    modal.querySelector('.builder-v2__zoom-img').src = imageUrl;
    modal.querySelector('.builder-v2__zoom-img').alt = colorName || '';
    modal.querySelector('.builder-v2__zoom-name').textContent = colorName || '';
    modal.classList.add('builder-v2__zoom-modal--active');
    modal.querySelector('.builder-v2__zoom-close').focus();

    document.addEventListener('keydown', swatchZoomEscHandler);
  }

  function closeSwatchZoom() {
    var modal = document.getElementById('builder-v2-swatch-zoom');
    if (!modal) return;
    modal.classList.remove('builder-v2__zoom-modal--active');
    modal.querySelector('.builder-v2__zoom-img').src = '';
    document.removeEventListener('keydown', swatchZoomEscHandler);
  }

  function swatchZoomEscHandler(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeSwatchZoom();
  }

  /* ============================================================
     PRE-LOAD COLOR IMAGES
     Deferred to after page load to avoid hurting LCP.
     Only pre-loads product featured images, not every variant.
     ============================================================ */
  (function preloadColorImages() {
    var colorBlock = findColorBlock();
    if (!colorBlock || !colorBlock.products) return;

    function doPreload() {
      colorBlock.products.forEach(function(p) {
        if (p.image) {
          var img = new Image();
          img.src = p.image;
        }
      });
    }

    // Defer until after initial paint
    if ('requestIdleCallback' in window) {
      requestIdleCallback(doPreload);
    } else {
      setTimeout(doPreload, 1000);
    }
  })();


  /* ============================================================
     GALLERY — Thumbnail clicks + Color swap
     ============================================================ */
  var galleryMain = dom.qs('[data-gallery-main]');
  var galleryThumbs = dom.qs('[data-gallery-thumbs]');
  var galleryDots = dom.qs('[data-gallery-dots]');

  if (galleryThumbs && galleryMain) {
    dom.on(galleryThumbs, 'click', '.builder-v2__thumb', function() {
      var idx = parseInt(this.getAttribute('data-thumb-index'), 10);
      goToSlide(idx);
    });
  }

  // Dot clicks → navigate to slide
  if (galleryDots) {
    dom.on(galleryDots, 'click', '.builder-v2__gallery-dot', function() {
      var idx = parseInt(this.getAttribute('data-dot-index'), 10);
      goToSlide(idx);
    });
  }

  // Prev/next arrow clicks - mobile + desktop. Wrap around at the ends so
  // users can keep cycling through the gallery without hitting a dead button.
  function getCurrentSlideIndex() {
    if (!galleryMain) return 0;
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('builder-v2__gallery-slide--active')) {
        return i;
      }
    }
    return 0;
  }

  var prevBtn = dom.qs('[data-gallery-prev]');
  var nextBtn = dom.qs('[data-gallery-next]');
  if (prevBtn && nextBtn && galleryMain) {
    var totalSlides = dom.qsa('.builder-v2__gallery-slide', galleryMain).length;
    dom.on(prevBtn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var current = getCurrentSlideIndex();
      var next = current === 0 ? totalSlides - 1 : current - 1;
      goToSlide(next);
    });
    dom.on(nextBtn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var current = getCurrentSlideIndex();
      var next = current === totalSlides - 1 ? 0 : current + 1;
      goToSlide(next);
    });
  }

  // Mobile scroll tracking for dots
  if (galleryMain && galleryDots) {
    var scrollTimeout;
    dom.on(galleryMain, 'scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
        var scrollLeft = galleryMain.scrollLeft;
        var width = galleryMain.offsetWidth;
        var idx = Math.round(scrollLeft / width);
        updateActiveDot(idx);
        updateActiveThumb(idx);
        updateCounter(idx);
      }, 50);
    });
  }

  // Gallery color swap — swaps the hero image (first slide) and first
  // thumbnail to match the selected color's hero image. ONLY fires
  // when the component product has a second image (hero_image) uploaded.
  // If only the swatch image exists, the gallery stays untouched.
  // This prevents swatch-quality thumbnails from being upscaled into
  // the main gallery. As Rai uploads proper hero images per color,
  // the swap automatically activates for those products.
  events.on('color:change', function(data) {
    if (!data.heroImage || !galleryMain) return;

    // Swap first slide to the hero image (already at 1200px from bridge)
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    if (slides.length > 0) {
      var firstImg = slides[0].querySelector('img');
      if (firstImg) {
        firstImg.src = data.heroImage;
        firstImg.alt = data.colorName || '';
      }
      goToSlide(0);
    }

    // Sync first thumbnail
    if (galleryThumbs) {
      var firstThumb = galleryThumbs.querySelector('.builder-v2__thumb img');
      if (firstThumb) {
        firstThumb.src = data.heroImage.replace(/width=\d+/, 'width=160');
        firstThumb.alt = data.colorName || '';
      }
    }
  });

  function goToSlide(idx) {
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    if (!slides[idx]) return;

    // Use CSS class for active slide (avoids inline style vs media query conflicts on resize)
    slides.forEach(function(s) { s.classList.remove('builder-v2__gallery-slide--active'); });
    slides[idx].classList.add('builder-v2__gallery-slide--active');

    // Mobile: also scroll to the slide position
    if (window.innerWidth < 769) {
      var slideWidth = galleryMain.offsetWidth;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      galleryMain.scrollTo({ left: slideWidth * idx, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateActiveThumb(idx);
    updateActiveDot(idx);
    updateCounter(idx);
  }

  function updateCounter(idx) {
    var counter = document.querySelector('[data-counter-current]');
    if (counter) counter.textContent = (idx + 1);
  }

  function updateActiveThumb(idx) {
    if (!galleryThumbs) return;
    var thumbs = dom.qsa('.builder-v2__thumb', galleryThumbs);
    thumbs.forEach(function(t) { t.classList.remove('builder-v2__thumb--active'); });
    if (thumbs[idx]) thumbs[idx].classList.add('builder-v2__thumb--active');
  }

  // Old info tabs (Description / Shipping / Measurement) removed.
  // Replaced by native HTML <details>/<summary> accordions that need
  // no JS for open/close behavior.

  // Desktop lightbox zoom
  // CRITICAL: theme's .page-container has transform:translate3d on desktop,
  // which creates a containing block for position:fixed descendants. This
  // means a lightbox inside .page-container is NOT relative to the viewport
  // it's relative to .page-container, causing it to be clipped/misaligned.
  // Fix: move the lightbox to <body> so it escapes the transformed ancestor.
  var lightbox = dom.qs('[data-lightbox]');
  var lightboxImg = dom.qs('[data-lightbox-img]');
  var lightboxClose = dom.qs('[data-lightbox-close]');

  if (lightbox && document.body) {
    document.body.appendChild(lightbox);
  }

  if (galleryMain && lightbox && lightboxImg) {
    galleryMain.addEventListener('click', function(e) {
      if (window.innerWidth < 769) return;
      var img = e.target.tagName === 'IMG' ? e.target : null;
      if (!img) return;
      var fullSrc = img.src.replace(/width=\d+/, 'width=1600');
      if (fullSrc === img.src) {
        fullSrc = img.src + (img.src.indexOf('?') >= 0 ? '&' : '?') + 'width=1600';
      }
      lightboxImg.src = fullSrc;
      lightboxImg.alt = img.alt || '';
      lightbox.classList.add('builder-v2__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeLightbox() {
      lightbox.classList.remove('builder-v2__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
      document.body.style.overflow = '';
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('builder-v2__lightbox--open')) {
        closeLightbox();
      }
    });
  }

  function updateActiveDot(idx) {
    if (!galleryDots) return;
    var dots = dom.qsa('.builder-v2__gallery-dot', galleryDots);
    dots.forEach(function(d) { d.classList.remove('builder-v2__gallery-dot--active'); });
    if (dots[idx]) dots[idx].classList.add('builder-v2__gallery-dot--active');
  }


  /* ============================================================
     UTILITY: POPULATE SELECT
     ============================================================ */
  function populateSelect(select, values, placeholder, selectedValue) {
    select.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function(val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val + '"';
      if (selectedValue !== null && selectedValue !== undefined && val === selectedValue) {
        opt.selected = true;
      }
      select.appendChild(opt);
    });
  }

  function populateFractionSelect(select) {
    select.innerHTML = '';
    for (var i = 0; i < fractions.VALUES.length; i++) {
      var opt = document.createElement('option');
      opt.value = fractions.VALUES[i];
      opt.textContent = fractions.LABELS[i] || '0"';
      select.appendChild(opt);
    }
  }


  /* ============================================================
     UTILITY: ERROR DISPLAY
     ============================================================ */
  function showError(msg) {
    var el = dom.qs('[data-builder-error]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('builder-v2__error--visible');
    // Auto-dismiss after 8 seconds (enough time to read + act)
    if (showError._timer) clearTimeout(showError._timer);
    showError._timer = setTimeout(function() {
      el.classList.remove('builder-v2__error--visible');
    }, 8000);
  }


  /* ============================================================
     UTILITY: HTML ESCAPE
     ============================================================ */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


  /* ============================================================
     ESTIMATED SHIP DATE BADGE (top of builder)
     Fills in the "Estimated Ship Date: May 4th" badge between the
     reviews snippet and the price block. Reads the same production_days
     metafield as the shipping timeline so there is one source of truth.
     Single date = today + production_days business days.
     ============================================================ */
  (function renderShipDateBadge() {
    var badge = document.querySelector('[data-ship-date-badge]');
    if (!badge) return;
    var rangeEl = badge.querySelector('[data-ship-date-range]');
    if (!rangeEl) return;

    var prodDays = parseInt(badge.getAttribute('data-production-days'), 10) || 0;
    if (prodDays === 0) {
      badge.style.display = 'none';
      return;
    }

    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function formatDate(d) {
      return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
    }

    var today = new Date();
    var shipDate = addBusinessDays(today, prodDays);

    rangeEl.textContent = ' ' + formatDate(shipDate);
  })();


  /* ============================================================
     INFO BOX — READ MORE smooth scroll
     The default browser jump-to-anchor would land the description
     under the fixed theme header. Use scrollIntoView with a small
     offset adjustment so the heading lands cleanly below the header.
     ============================================================ */
  (function bindInfoBoxReadMore() {
    var link = document.querySelector('[data-info-box-readmore]');
    if (!link) return;
    var target = document.getElementById('builder-v2-description');
    if (!target) return;

    link.addEventListener('click', function(e) {
      e.preventDefault();
      var headerOffset = 120; // matches v2 page-container padding-top + breathing room
      var rect = target.getBoundingClientRect();
      var top = rect.top + window.pageYOffset - headerOffset;
      var reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: top,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      // Update the URL hash without triggering the default jump
      if (history.replaceState) {
        history.replaceState(null, '', '#builder-v2-description');
      }
    });
  })();


  /* ============================================================
     STEP 2 "Measurement information" LINK
     Delegated handler — the link is rendered dynamically inside
     renderSizeStep, so we listen on document and resolve at click time.
     Behaviour mirrors bindInfoBoxReadMore but also force-opens the
     <details> accordion (anchor-click alone won't open it).
     ============================================================ */
  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('[data-measure-info-link]');
    if (!link) return;
    var target = document.getElementById('builder-v2-measure-install');
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS' && !target.open) target.open = true;
    var headerOffset = 120;
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - headerOffset;
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (history.replaceState) {
      history.replaceState(null, '', '#builder-v2-measure-install');
    }
  });


  /* ============================================================
     SHIPPING TIMELINE
     Renders a 3-step Order Arrival Estimate from product metafields.
     Single dates, no range:
       Ordered   = today
       Order Ready = today + production_days business days
       Delivered = Order Ready + shipping_days business days
     Both production_days and shipping_days are merchant-editable
     metafields so the date logic updates without a code change.
     ============================================================ */
  (function renderShippingTimeline() {
    // Target the dedicated metafield bridge (has BOTH data-production-days
    // and data-shipping-days). Querying just [data-production-days] would
    // match the ship-date badge first, which only carries production_days,
    // so shipDays would silently fall back to its default and the
    // shipping_days metafield would appear to have no effect.
    var prodEl = dom.qs('[data-shipping-days]');
    var estEl = dom.qs('[data-shipping-estimate]');
    if (!prodEl || !estEl) return;

    var prodDays = parseInt(prodEl.getAttribute('data-production-days'), 10) || 0;
    var shipDays = parseInt(prodEl.getAttribute('data-shipping-days'), 10) || 7;
    if (prodDays === 0) return;

    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function formatDate(d) {
      return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
    }

    var today = new Date();
    var readyDate = addBusinessDays(today, prodDays);
    var deliverDate = addBusinessDays(readyDate, Math.max(1, shipDays));

    // Callout box with truck icon header, matching MeasureSafe visual language
    var iconOrder = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var iconTruck = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var iconDelivered = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a4 4 0 0 0-8 0v2"/><path d="M9 14l2 2 4-4"/></svg>';

    // Layout: arrival-box (compact callout with just the timeline) on the
    // LEFT, and arrival-info (note + bullets) on the RIGHT on desktop.
    // Stacks vertically on mobile. Per Warwick PDP review v2: "Make the
    // box just a small section. If they could sit to the right of the
    // Order Arrival Estimate infographic on Desktop, and underneath on
    // Mobile, that would be great."
    estEl.innerHTML =
      '<div class="builder-v2__arrival-layout">' +
        // LEFT: compact callout box (header + 3 timeline steps only)
        '<div class="builder-v2__arrival-box">' +
          '<div class="builder-v2__arrival-header">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<rect x="1" y="3" width="15" height="13"/>' +
              '<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>' +
              '<circle cx="5.5" cy="18.5" r="2.5"/>' +
              '<circle cx="18.5" cy="18.5" r="2.5"/>' +
            '</svg>' +
            '<span>Order Arrival Estimate</span>' +
          '</div>' +
          '<div class="builder-v2__shipping-timeline">' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconOrder + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(today) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Ordered</span>' +
              '</div>' +
            '</div>' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconTruck + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(readyDate) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Order Ready</span>' +
              '</div>' +
            '</div>' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconDelivered + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(deliverDate) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Delivered</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        // RIGHT: bullet points from section setting (editable in Theme Editor)
        '<div class="builder-v2__arrival-info">' +
          (function() {
            var bulletsRaw = Core.parseJSON('builder-timeline-bullets');
            if (bulletsRaw && bulletsRaw.trim()) {
              var lines = bulletsRaw.split('\n').filter(function(l) { return l.trim(); });
              var html = '<ul class="builder-v2__arrival-bullets">' +
                lines.map(function(l) {
                  return '<li>' + l.trim()
                    .replace(/\[production_days\]/g, prodDays)
                    .replace(/\[production_days_plus_2\]/g, (prodDays + 2)) + '</li>';
                }).join('') + '</ul>';
              return html;
            }
            return '<ul class="builder-v2__arrival-bullets">' +
              '<li>Free shipping on all orders inside the contiguous United States.</li>' +
              '<li>On average, customers receive their custom measured and cut blinds in 2 weeks from placing an order.</li>' +
              '<li>All blinds and shades are custom made to your specifications and typically ship ' + prodDays + ' to ' + (prodDays + 2) + ' business days after ordering.</li>' +
              '<li>Shipping times depend on your location and are usually 2-5 business days.</li>' +
              '<li>Our customer service team is always happy to check on the status and whereabouts of your order.</li>' +
            '</ul>';
          })() +
        '</div>' +
      '</div>' +
      // Note moved BELOW the layout per Warwick: "Move Note underneath
      // the Order Arrival Estimate infographic"
      '<p class="builder-v2__arrival-note">Note: Delivery times begin AFTER production. Oversize blinds must be shipped ground and may take longer to arrive. Estimated arrival time does not include holidays.</p>';
  })();


  /* ============================================================
     GOOGLE SHOPPING DEEP-LINK — auto-select color from URL
     If the URL contains ?color=Ivory (from a Google Shopping listing
     submitted by Feedoptimize), find the matching swatch and click it
     programmatically. This pre-selects the color, swaps the gallery
     image, updates the URL, and advances to step 2.
     Runs after all steps have rendered so swatches are in the DOM.
     ============================================================ */
  (function autoSelectColorFromURL() {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return; } // IE11 fallback: skip auto-select

    var colorParam = params.get('color');
    if (!colorParam) return;

    colorParam = decodeURIComponent(colorParam).trim();
    if (!colorParam) return;

    var colorLower = colorParam.toLowerCase();

    // Find matching swatch across all color groups (case-insensitive)
    var swatches = dom.qsa('.builder-v2__swatch');
    var match = null;
    for (var i = 0; i < swatches.length; i++) {
      var swatchColor = swatches[i].getAttribute('data-color');
      if (swatchColor && swatchColor.trim().toLowerCase() === colorLower) {
        match = swatches[i];
        break;
      }
    }

    if (match) {
      // Small delay ensures the DOM is fully painted and event
      // delegation is bound before the programmatic click fires
      setTimeout(function() { match.click(); }, 50);
    }
  })();


  // Expose for debugging
  window.BuilderRoller = {
    store: store,
    pricing: pricing,
    recalculatePrice: recalculatePrice
  };

})();

